/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  _Any: { input: any; output: any; }
  _FieldSet: { input: any; output: any; }
};

/** IdPへ送るプロフィールプレビュー */
export type AccountMigrationProfilePreview = {
  __typename: 'AccountMigrationProfilePreview';
  currentValue?: Maybe<Scalars['String']['output']>;
  field: IdpProfilePreviewField;
  outgoingValue?: Maybe<Scalars['String']['output']>;
};

/**
 * アカウント移行時に追加で必要な項目。
 * DATE_OF_BIRTH は IdP migrate-user で必須だが KLEW 側で未設定の場合に補完入力を要求する。
 * GENDER は KLEW 未設定でも prefer_not_to_say で既定送信できるため含めない。
 */
export enum AccountMigrationRequiredField {
  AdministrativeArea = 'ADMINISTRATIVE_AREA',
  CountryOfResidence = 'COUNTRY_OF_RESIDENCE',
  DateOfBirth = 'DATE_OF_BIRTH',
  MarketingOptIn = 'MARKETING_OPT_IN',
  Password = 'PASSWORD',
  TermsAccepted = 'TERMS_ACCEPTED'
}

/** アカウント移行要件 */
export type AccountMigrationRequirementsPayload = {
  __typename: 'AccountMigrationRequirementsPayload';
  profilePreview: Array<AccountMigrationProfilePreview>;
  requiredFields: Array<AccountMigrationRequiredField>;
};

/** ファンからの投稿へリアクション追加 入力 */
export type AddArtistReactionToFanPostInput = {
  /** チャンネルID */
  channelID: Scalars['ID']['input'];
  type: ArtistReactionType;
  /** リアクション対象コンテンツID */
  ulid: Scalars['ID']['input'];
};

/** ファンからの投稿へリアクション追加 ペイロード */
export type AddArtistReactionToFanPostPayload = AddArtistReactionToFanPostPayloadSuccess | ErrorInternal | ErrorNotFound | ErrorPreconditionFailed | ErrorValidationFailed;

/** ファンからの投稿へリアクション追加 成功 */
export type AddArtistReactionToFanPostPayloadSuccess = ResultBase & {
  __typename: 'AddArtistReactionToFanPostPayloadSuccess';
  ok: Scalars['Boolean']['output'];
  reaction: ArtistReaction;
};

/**  アーティスト  */
export type Artist = {
  __typename: 'Artist';
  /**  バイオグラフィ  */
  biography?: Maybe<Scalars['String']['output']>;
  /**  アーティストカラー  */
  color: Scalars['String']['output'];
  /**  登録日時  */
  createdAt: Scalars['DateTime']['output'];
  /**  イベントリスト（アーティストID）  */
  events: EventConnection;
  /**  ヘッダー画像URL  */
  headerImage?: Maybe<Image>;
  /**  アイコン画像  */
  iconImage?: Maybe<Image>;
  /**  アーティストID  */
  id: Scalars['ID']['output'];
  /** 対象アーティストをフォローしているかどうか */
  isFollowing: Scalars['Boolean']['output'];
  /**  本登録フラグ  */
  isFullyRegistered: Scalars['Boolean']['output'];
  /**  リンク  */
  links: Array<Link>;
  /**  アーティスト名  */
  name: Scalars['String']['output'];
  /**  アーティスト名(英語)  */
  nameEn: Scalars['String']['output'];
  /**  アーティスト名(カナ)  */
  nameKana: Scalars['String']['output'];
  /**  オーナーが管理するアーティストオフィシャルアカウントリスト  */
  officialAccounts?: Maybe<Array<ArtistOfficial>>;
  /**  紐づく公演チャンネル  */
  performanceChannels: PerformanceChannelConnection;
  /**  スラッグ  */
  slug?: Maybe<Scalars['String']['output']>;
  /**  チケット提供方式  */
  ticketProvisionType: TicketProvisionType;
  /**  更新日時  */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/**  アーティスト  */
export type ArtistBiographyArgs = {
  format?: InputMaybe<TagFormat>;
};


/**  アーティスト  */
export type ArtistEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<EventSortOrder>;
  statuses?: InputMaybe<Array<EventStatus>>;
};


/**  アーティスト  */
export type ArtistPerformanceChannelsArgs = {
  actionable?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<PerformanceChannelSortOrder>;
};

/**  アーティストコネクション  */
export type ArtistConnection = {
  __typename: 'ArtistConnection';
  edges: Array<ArtistEdge>;
  pageInfo: PageInfo;
};

/**  アーティストエッジ  */
export type ArtistEdge = {
  __typename: 'ArtistEdge';
  cursor: Scalars['String']['output'];
  node: Artist;
};

export type ArtistOfficial = {
  __typename: 'ArtistOfficial';
  /**  アーティスト  */
  artist: Artist;
  /**  アーティストアイコン画像URL  */
  iconImage?: Maybe<Image>;
  /**  アーティストオフィシャルID  */
  id: Scalars['ID']['output'];
  /**  アーティストオフィシャル名  */
  name: Scalars['String']['output'];
  /**  優先度（小さいほど上位）  */
  priority: Scalars['Int']['output'];
};

export type ArtistOfficialWhoTookAction = {
  __typename: 'ArtistOfficialWhoTookAction';
  /**  アーティストオフィシャルアカウント  */
  artistOfficial: ArtistOfficial;
  /**  最終アクション日時（投稿 または いいね）  */
  lastActionedAt: Scalars['DateTime']['output'];
};

/**  アーティスト投稿  */
export type ArtistPost = ChannelContentBase & {
  __typename: 'ArtistPost';
  /**  投稿したアーティストオフィシャル  */
  artistOfficial: ArtistOfficial;
  /**  投稿文（ネタバレフラグがTRUEで閲覧権限が無い場合、null）  */
  body?: Maybe<Scalars['String']['output']>;
  channelID: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  /**  投稿画像（複数あり）  */
  images?: Maybe<Array<Image>>;
  isMasked: Scalars['Boolean']['output'];
  isSpoiler: Scalars['Boolean']['output'];
  parentContent?: Maybe<ChannelContent>;
  /**  親コンテンツ  */
  parentContentID?: Maybe<Scalars['ID']['output']>;
  /**  リアクション  */
  reactions: ArtistPostReactions;
  ulid: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**  アーティスト投稿 コネクション  */
export type ArtistPostConnection = {
  __typename: 'ArtistPostConnection';
  edges: Array<ArtistPostEdge>;
  pageInfo: PageInfo;
};

/**  アーティスト投稿 エッジ  */
export type ArtistPostEdge = {
  __typename: 'ArtistPostEdge';
  cursor: Scalars['String']['output'];
  node: ArtistPost;
};

/**  アーティスト投稿に対するリアクション  */
export type ArtistPostReactions = {
  __typename: 'ArtistPostReactions';
  /**  アーティストからのリアクション  */
  artistReactions?: Maybe<Array<ArtistReaction>>;
  /**  自分（ファンアカウント）のリアクション  */
  myReactions?: Maybe<Array<FanReaction>>;
  /**  ファンからのリアクションカウント  */
  reactionCounts: Array<FanReactionCount>;
};

/** アーティストからのリアクション */
export type ArtistReaction = {
  __typename: 'ArtistReaction';
  /** リアクションしたアーティストオフィシャル */
  artistOfficial: ArtistOfficial;
  /** リアクション対象コンテンツ */
  content: ChannelContent;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** リアクション種別 */
  reactionType: ArtistReactionType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** アーティストリアクション対象種別 */
export enum ArtistReactionTargetType {
  FanPost = 'FAN_POST'
}

/** アーティストリアクション種別 */
export enum ArtistReactionType {
  Like = 'LIKE'
}

export type BackwardPaginationInput = {
  before?: InputMaybe<Scalars['String']['input']>;
  last: Scalars['Int']['input'];
};

/**  Emailアドレス変更用入力  */
export type ChangeEmailAddressInput = {
  email: Scalars['String']['input'];
};

/**  Emailアドレス変更用ペイロード  */
export type ChangeEmailAddressPayload = ChangeEmailAddressPayloadSuccess | ErrorEmailVerificationAlreadyInUse | ErrorEmailVerificationAlreadyVerified | ErrorInternal | ErrorValidationFailed;

/**  Emailアドレス変更用ペイロード（成功）  */
export type ChangeEmailAddressPayloadSuccess = ResultBase & {
  __typename: 'ChangeEmailAddressPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

export type Channel = PerformanceChannel;

export type ChannelConnection = {
  __typename: 'ChannelConnection';
  edges: Array<ChannelEdge>;
  pageInfo: PageInfo;
};

/**  チャンネルコンテンツ  */
export type ChannelContent = ArtistPost | FanPost;

export type ChannelContentBase = {
  /**  チャンネルID  */
  channelID: Scalars['ID']['output'];
  /**  投稿日時  */
  createdAt: Scalars['DateTime']['output'];
  /**  マスクされているかどうか  */
  isMasked: Scalars['Boolean']['output'];
  /**  ネタバレかどうか  */
  isSpoiler: Scalars['Boolean']['output'];
  parentContent?: Maybe<ChannelContent>;
  /**  親コンテンツ  */
  parentContentID?: Maybe<Scalars['ID']['output']>;
  /**  コンテンツID（ULID）  */
  ulid: Scalars['ID']['output'];
  /**  更新日時  */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**  チャンネルコンテンツ コネクション  */
export type ChannelContentConnection = {
  __typename: 'ChannelContentConnection';
  edges: Array<ChannelContentEdge>;
  pageInfo: PageInfo;
};

/**  チャンネルコンテンツ エッジ  */
export type ChannelContentEdge = {
  __typename: 'ChannelContentEdge';
  cursor: Scalars['String']['output'];
  node: ChannelContent;
};

export enum ChannelContentsSortOrder {
  /**  投稿日時の昇順  */
  PostedAtAsc = 'POSTED_AT_ASC'
}

export type ChannelEdge = {
  __typename: 'ChannelEdge';
  cursor: Scalars['String']['output'];
  node: Channel;
};

export type ChannelInterface = {
  /**  対象チャンネルでアクションを起こしたアーティストオフィシャルアカウントを取得  */
  artistOfficialsWhoTookAction?: Maybe<Array<ArtistOfficialWhoTookAction>>;
  /**  コンテンツ（単体取得）  */
  content: ChannelContent;
  /**  コンテンツ（リスト取得）  */
  contents: ChannelContentConnection;
  /**  チャンネル説明  */
  description?: Maybe<Scalars['String']['output']>;
  /**  チャンネルID  */
  id: Scalars['ID']['output'];
  /**  チャンネル名  */
  name: Scalars['String']['output'];
  /**  リクエストしているファンの権限情報  */
  permission: ChannelPermission;
  /**  ピン留めされているチャンネルコンテンツを取得する  */
  pinnedChannelContents: PinnedChannelContentConnection;
  /**  スーパーメッセージの選択肢を取得  */
  superMessageMasters?: Maybe<Array<SuperMessageMaster>>;
  /**  チャンネルタイプ  */
  type: ChannelType;
};


export type ChannelInterfaceContentArgs = {
  ulid: Scalars['ID']['input'];
};


export type ChannelInterfaceContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<ChannelContentsSortOrder>;
};


export type ChannelInterfaceDescriptionArgs = {
  format?: InputMaybe<TagFormat>;
};


export type ChannelInterfacePinnedChannelContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<PinnedChannelContentsSortOrder>;
};

/**  チャンネル権限情報  */
export type ChannelPermission = {
  __typename: 'ChannelPermission';
  /**  アクション可能（一つでも権限を持っている）  */
  actionable: Scalars['Boolean']['output'];
  /**  チャンネル権限詳細  */
  detail: ChannelPermissionDetail;
};

/**  チャンネル権限詳細  */
export type ChannelPermissionDetail = {
  __typename: 'ChannelPermissionDetail';
  /**  投稿可能かどうか  */
  postable: Scalars['Boolean']['output'];
  /**  リアクション（いいね）可能かどうか  */
  reactable: Scalars['Boolean']['output'];
  /**  ネタバレ投稿を閲覧可能かどうか  */
  spoilerViewable: Scalars['Boolean']['output'];
};

export enum ChannelType {
  /**  アーティストgeneral  */
  Artist = 'ARTIST',
  /**  アーティスト公演チャンネル  */
  ArtistPerformance = 'ARTIST_PERFORMANCE'
}

export enum ContentType {
  ImageJpeg = 'IMAGE_JPEG',
  ImagePng = 'IMAGE_PNG'
}

/** IdP認証済みアカウントから新規アカウントを作成する入力 */
export type CreateAccountFromIdpInput = {
  enableRecommendationNotification: Scalars['Boolean']['input'];
  realFamilyName: Scalars['String']['input'];
  realFamilyNameKana?: InputMaybe<Scalars['String']['input']>;
  realFirstName: Scalars['String']['input'];
  realFirstNameKana?: InputMaybe<Scalars['String']['input']>;
};

/** IdP認証済みアカウントからの新規アカウント作成ペイロード */
export type CreateAccountFromIdpPayload = CreateAccountFromIdpPayloadSuccess | ErrorAlreadyExists | ErrorIdpAccountConflict | ErrorInternal | ErrorPermissionDenied | ErrorPreconditionFailed | ErrorValidationFailed;

/** IdP認証済みアカウントからの新規アカウント作成成功 */
export type CreateAccountFromIdpPayloadSuccess = ResultBase & {
  __typename: 'CreateAccountFromIdpPayloadSuccess';
  me: Me;
  ok: Scalars['Boolean']['output'];
};

/** チャンネルコンテンツへリアクションする 入力 */
export type CreateFanReactionToChannelContentInput = {
  /** チャンネルID */
  channelID: Scalars['ID']['input'];
  /** リアクション種別 */
  type: FanReactionType;
  /** リアクション対象コンテンツID */
  ulid: Scalars['ID']['input'];
};

/** チャンネルコンテンツへリアクションする 出力 */
export type CreateFanReactionToChannelContentPayload = CreateFanReactionToChannelContentPayloadSuccess | ErrorHasNotVerifiedEmail | ErrorInternal | ErrorNotFound | ErrorPreconditionFailed | ErrorValidationFailed;

/** チャンネルコンテンツへリアクションする 出力（成功） */
export type CreateFanReactionToChannelContentPayloadSuccess = ResultBase & {
  __typename: 'CreateFanReactionToChannelContentPayloadSuccess';
  fanReaction: FanReaction;
  ok: Scalars['Boolean']['output'];
};

/**  クレジットカード  */
export type CreditCard = {
  __typename: 'CreditCard';
  /**  ブランド  */
  brand: CreditCardBrand;
  /**  有効期限(月)  */
  expiryMonth: Scalars['String']['output'];
  /**  有効期限(年)  */
  expiryYear: Scalars['String']['output'];
  /**  マスキングされたカード番号  */
  number: Scalars['String']['output'];
};

/**  クレジットカードブランド  */
export enum CreditCardBrand {
  Amex = 'Amex',
  Diners = 'Diners',
  Jcb = 'JCB',
  Master = 'Master',
  Unknown = 'Unknown',
  Visa = 'Visa'
}

/** クレジットカードによる注文 */
export type CreditCardPaymentOrder = PaymentOrder & {
  __typename: 'CreditCardPaymentOrder';
  /**  総額（税込）  */
  amountIncludingTax: Scalars['Int']['output'];
  /**  作成日時  */
  createdAt: Scalars['DateTime']['output'];
  /**  ステータス  */
  creditCardPaymentOrderStatus: CreditCardPaymentOrderStatus;
  /**  失敗事由  */
  failedReason?: Maybe<PaymentFailedReason>;
  /**  ファンID  */
  fanID: Scalars['ID']['output'];
  /**  注文ID  */
  id: Scalars['ID']['output'];
  /**  アイテム（Number昇順）  */
  items: Array<PaymentOrderItem>;
  /**  注文に関連するアイテム (注文完了の場合のみ) */
  relatedItem?: Maybe<PaymentRelatedItem>;
  /**  セールID（チケットセールの場合、チケットセールID）  */
  saleID: Scalars['ID']['output'];
  /**  販売種別  */
  saleType: SaleType;
  /**  更新日時  */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum CreditCardPaymentOrderStatus {
  /**  キャンセル  */
  Canceled = 'CANCELED',
  /**  完了  */
  Completed = 'COMPLETED',
  /**  失敗  */
  Failed = 'FAILED',
  /**  処理中  */
  Processing = 'PROCESSING'
}

export type CropInfo = {
  __typename: 'CropInfo';
  heightPx: Scalars['Float']['output'];
  rotateDeg: Scalars['Float']['output'];
  scaleX: Scalars['Float']['output'];
  scaleY: Scalars['Float']['output'];
  widthPx: Scalars['Float']['output'];
  xPx: Scalars['Float']['output'];
  yPx: Scalars['Float']['output'];
};

export type CropInfoInput = {
  heightPx: Scalars['Float']['input'];
  rotateDeg?: Scalars['Float']['input'];
  scaleX?: Scalars['Float']['input'];
  scaleY?: Scalars['Float']['input'];
  widthPx: Scalars['Float']['input'];
  xPx: Scalars['Float']['input'];
  yPx: Scalars['Float']['input'];
};

/** アーティストオフィシャルアカウントとしてファン投稿を削除（非表示）にする 入力 */
export type DeleteFanContentAsArtistOfficialInput = {
  /**  チャンネルID  */
  channelID: Scalars['ID']['input'];
  /**  投稿ID  */
  postID: Scalars['ID']['input'];
};

/** アーティストオフィシャルアカウントとしてファン投稿を削除（非表示）にする ペイロード */
export type DeleteFanContentAsArtistOfficialPayload = DeleteFanContentAsArtistOfficialPayloadSuccess | ErrorInternal | ErrorNotFound | ErrorNotMyChannelContent | ErrorValidationFailed;

/** アーティストオフィシャルアカウントとしてファン投稿を削除（非表示）にする 成功 */
export type DeleteFanContentAsArtistOfficialPayloadSuccess = ResultBase & {
  __typename: 'DeleteFanContentAsArtistOfficialPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

/** チャンネルコンテンツへのリアクションを削除する 入力 */
export type DeleteFanReactionToChannelContentInput = {
  /** チャンネルID */
  channelID: Scalars['ID']['input'];
  /** リアクション種別 */
  type: FanReactionType;
  /** リアクション対象コンテンツID */
  ulid: Scalars['ID']['input'];
};

/** チャンネルコンテンツへのリアクションを削除する 出力 */
export type DeleteFanReactionToChannelContentPayload = DeleteFanReactionToChannelContentPayloadSuccess | ErrorHasNotVerifiedEmail | ErrorInternal | ErrorNotFound | ErrorValidationFailed;

/** チャンネルコンテンツへのリアクションを削除する 出力（成功） */
export type DeleteFanReactionToChannelContentPayloadSuccess = ResultBase & {
  __typename: 'DeleteFanReactionToChannelContentPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

/** アーティスト公演投稿を削除にする 入力 */
export type DeleteMyArtistPerformanceContentInput = {
  /**  チャンネルID  */
  channelID: Scalars['ID']['input'];
  /**  投稿ID  */
  postID: Scalars['ID']['input'];
};

/** アーティスト公演投稿を削除にする ペイロード */
export type DeleteMyArtistPerformanceContentPayload = DeleteMyArtistPerformanceContentPayloadSuccess | ErrorInternal | ErrorNotFound | ErrorValidationFailed;

/** アーティスト公演投稿を削除にする 成功 */
export type DeleteMyArtistPerformanceContentPayloadSuccess = ResultBase & {
  __typename: 'DeleteMyArtistPerformanceContentPayloadSuccess';
  ok: Scalars['Boolean']['output'];
  /**  投稿ID  */
  postID: Scalars['ID']['output'];
};

/** 自身が投稿したファン投稿を削除する 入力 */
export type DeleteMyFanContentInput = {
  /**  チャンネルID  */
  channelID: Scalars['ID']['input'];
  /**  コンテンツID（ULID）  */
  ulid: Scalars['ID']['input'];
};

/** 自身が投稿したファン投稿を削除する ペイロード */
export type DeleteMyFanContentPayload = DeleteMyFanContentPayloadSuccess | ErrorInternal | ErrorNotFound | ErrorValidationFailed;

/** 自身が投稿したファン投稿を削除する 成功 */
export type DeleteMyFanContentPayloadSuccess = ResultBase & {
  __typename: 'DeleteMyFanContentPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

/**  外部チケット登録にて作成したTicketApplicationを削除するペイロード  */
export type DeleteTicketApplicationCreatedByExternalTicketPayload = DeleteTicketApplicationCreatedByExternalTicketPayloadSuccess | ErrorInternal | ErrorNotFound | ErrorValidationFailed;

/**  外部チケット登録にて作成したTicketApplicationを削除するペイロード（成功）  */
export type DeleteTicketApplicationCreatedByExternalTicketPayloadSuccess = ResultBase & {
  __typename: 'DeleteTicketApplicationCreatedByExternalTicketPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

/**  特定のEメール通知設定を無効にする 入力  */
export type DisableMyEmailNotificationSettingsInput = {
  types: Array<MyEmailNotificationType>;
};

/**  特定のEメール通知設定を無効にする ペイロード  */
export type DisableMyEmailNotificationSettingsPayload = DisableMyEmailNotificationSettingsPayloadSuccess | ErrorInternal | ErrorNotFound | ErrorValidationFailed;

/**  特定のEメール通知設定を無効にする ペイロード（成功）  */
export type DisableMyEmailNotificationSettingsPayloadSuccess = ResultBase & {
  __typename: 'DisableMyEmailNotificationSettingsPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

export type DummyInput = {
  dummyID?: InputMaybe<Scalars['String']['input']>;
};

export type DummyPayload = {
  __typename: 'DummyPayload';
  dummyID?: Maybe<Scalars['String']['output']>;
};

/**  特定のEメール通知設定を有効にする 入力  */
export type EnableMyEmailNotificationSettingsInput = {
  types: Array<MyEmailNotificationType>;
};

/**  特定のEメール通知設定を有効にする ペイロード  */
export type EnableMyEmailNotificationSettingsPayload = EnableMyEmailNotificationSettingsPayloadSuccess | ErrorInternal | ErrorNotFound | ErrorValidationFailed;

/**  特定のEメール通知設定を有効にする ペイロード（成功）  */
export type EnableMyEmailNotificationSettingsPayloadSuccess = ResultBase & {
  __typename: 'EnableMyEmailNotificationSettingsPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

/**  入力値のエンティティが既に存在するエラー  */
export type ErrorAlreadyExists = FanUserError & {
  __typename: 'ErrorAlreadyExists';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/**  既にレビュー中 または 有効なチケット申し込みを持っているエラー  */
export type ErrorAlreadyHasReviewingOrActiveTicketApplication = FanUserError & {
  __typename: 'ErrorAlreadyHasReviewingOrActiveTicketApplication';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/**  購入後参照フラグをTrue=既読とできないチケットサマリエラー  */
export type ErrorCannotMarkTicketSummaryAsRead = FanUserError & {
  __typename: 'ErrorCannotMarkTicketSummaryAsRead';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/**  クレジットカード登録枚数上限超過エラー  */
export type ErrorCreditCardRegistrationLimitExceeded = FanUserError & {
  __typename: 'ErrorCreditCardRegistrationLimitExceeded';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/**  異なるアーティストのチャンネルエラー  */
export type ErrorDifferentArtistChannel = FanUserError & {
  __typename: 'ErrorDifferentArtistChannel';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/**  別のアカウントで登録済みのEmailアドレスで変更または認証した場合のエラー  */
export type ErrorEmailVerificationAlreadyInUse = FanUserError & {
  __typename: 'ErrorEmailVerificationAlreadyInUse';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/**  認証済みEmailアドレスで変更または認証した場合のエラー  */
export type ErrorEmailVerificationAlreadyVerified = FanUserError & {
  __typename: 'ErrorEmailVerificationAlreadyVerified';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/**  外部チケット登録の受付終了エラー  */
export type ErrorExternalTicketRegistrationScheduleHasEnded = FanUserError & {
  __typename: 'ErrorExternalTicketRegistrationScheduleHasEnded';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/**  ファンのステータスが不正な場合のエラー */
export type ErrorFanStatusInvalid = FanUserError & {
  __typename: 'ErrorFanStatusInvalid';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/**  Eメールアドレス未認証エラー  */
export type ErrorHasNotVerifiedEmail = FanUserError & {
  __typename: 'ErrorHasNotVerifiedEmail';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/**
 * IdP連携の競合エラー。
 * 別の `sub` と連携済み / この `sub` が別アカウントに紐付いている /
 * 同一 email のアカウントが複数あり一意に決められない / 退会済み等で自動連携できない、
 * といった自動復旧不可の競合を表す。`resolveIdpSignIn` の `CONFLICT` status に対応する。
 */
export type ErrorIdpAccountConflict = FanUserError & {
  __typename: 'ErrorIdpAccountConflict';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/**  システム内部エラー  */
export type ErrorInternal = FanUserError & {
  __typename: 'ErrorInternal';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/**  キャンセルできないチケット申込エラー  */
export type ErrorNonCancelableTicketApplication = FanUserError & {
  __typename: 'ErrorNonCancelableTicketApplication';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/**  指定IDに紐づくエンティティが存在しないエラー  */
export type ErrorNotFound = FanUserError & {
  __typename: 'ErrorNotFound';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/** 自アーティスト投稿ではないエラー */
export type ErrorNotMyArtistContent = FanUserError & {
  __typename: 'ErrorNotMyArtistContent';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/** 自身が管理するチャンネルコンテンツではないエラー */
export type ErrorNotMyChannelContent = FanUserError & {
  __typename: 'ErrorNotMyChannelContent';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/** 自身が投稿したファン投稿ではないエラー */
export type ErrorNotMyFanContent = FanUserError & {
  __typename: 'ErrorNotMyFanContent';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/**  権限無しエラー  */
export type ErrorPermissionDenied = FanUserError & {
  __typename: 'ErrorPermissionDenied';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/**  データ挿入/更新の条件を満たしていないエラー  */
export type ErrorPreconditionFailed = FanUserError & {
  __typename: 'ErrorPreconditionFailed';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/**  reCAPTCHA評価の結果、不正の可能性があるエラー  */
export type ErrorRecaptchaScoreError = FanUserError & {
  __typename: 'ErrorRecaptchaScoreError';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/**  入力値チェックエラー  */
export type ErrorValidationFailed = FanUserError & {
  __typename: 'ErrorValidationFailed';
  /**  入力チェックエラー詳細  */
  details?: Maybe<Array<ErrorValidationFailedDetail>>;
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/**  入力値チェックエラー詳細  */
export type ErrorValidationFailedDetail = {
  __typename: 'ErrorValidationFailedDetail';
  /**  エラーの原因となった属性  */
  attribute: Scalars['String']['output'];
  /**  TOO_LONG または TOO_SHORT の場合、このフィールドに最大/最小長が設定されます。 */
  limitLength?: Maybe<Scalars['Int']['output']>;
  /**  エラーメッセージ（他のフィールドから読み取れない補足テキストが設定される） */
  message: Scalars['String']['output'];
  /**  入力値チェックエラー事由  */
  reason: ErrorValidationFailedReason;
};

/**  入力値チェックエラー原因  */
export enum ErrorValidationFailedReason {
  Blank = 'BLANK',
  Invalid = 'INVALID',
  NgWord = 'NG_WORD',
  Required = 'REQUIRED',
  TooLong = 'TOO_LONG',
  TooShort = 'TOO_SHORT',
  UnexpectedType = 'UNEXPECTED_TYPE'
}

/**  イベント  */
export type Event = {
  __typename: 'Event';
  /**  作成日時  */
  createdAt: Scalars['DateTime']['output'];
  /**  説明（利用されるタグについては別途定義）  */
  description: Scalars['String']['output'];
  /**  ID  */
  id: Scalars['ID']['output'];
  /**  画像  */
  image?: Maybe<Image>;
  /**  内部チケットURL  */
  internalTicketUrl?: Maybe<Scalars['String']['output']>;
  /**  イベント（ツアー）名  */
  name: Scalars['String']['output'];
  /**  各種公演情報  */
  performanceInfo: PerformanceInfo;
  /**  検索用キーワード  */
  searchKeywords?: Maybe<Array<Scalars['String']['output']>>;
  /**  スラッグ  */
  slug?: Maybe<Scalars['String']['output']>;
  /**  ステータス（紐づく公演・販売スケジュールから情報を集約し返却）  */
  status: EventStatus;
  /**  チケット提供方式  */
  ticketProvisionType: TicketProvisionType;
  /**  更新日時  */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/**  イベント  */
export type EventDescriptionArgs = {
  format?: InputMaybe<TagFormat>;
};

/**  Eventバッジ  */
export type EventBadge = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  image: Image;
  name: Scalars['String']['output'];
  performance: Performance;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum EventBadgeOrder {
  /**  作成日時の降順  */
  CreatedAtDesc = 'CREATED_AT_DESC'
}

/**  CHAINS運営ピックアップイベントリスト コネクション  */
export type EventConnection = {
  __typename: 'EventConnection';
  edges: Array<EventEdge>;
  pageInfo: PageInfo;
};

/**  CHAINS運営ピックアップイベントリスト エッジ  */
export type EventEdge = {
  __typename: 'EventEdge';
  cursor: Scalars['String']['output'];
  node: Event;
};

/**  イベント開催期間  */
export type EventPeriod = {
  __typename: 'EventPeriod';
  /**  公演終了最遅日  */
  endDate: Scalars['DateTime']['output'];
  /**  公演開始最早日  */
  startDate: Scalars['DateTime']['output'];
};

export enum EventSortOrder {
  StartPublicAtDesc = 'START_PUBLIC_AT_DESC'
}

/**  イベント ステータス  */
export enum EventStatus {
  /**  販売開始前（公開されている販売スケジュールで販売中なし）  */
  BeforeSale = 'BEFORE_SALE',
  /**  イベント（全公演）キャンセル  */
  Cancelled = 'CANCELLED',
  /**  イベント 受付終了  */
  Closed = 'CLOSED',
  /**  イベント終了  */
  Ended = 'ENDED',
  /**  販売中（公開・販売されている販売スケジュールあり）  */
  OnSale = 'ON_SALE',
  /**  イベント（全販売スケジュール）完売  */
  SoldOut = 'SOLD_OUT'
}

/**  イベント主催者  */
export type Eventer = {
  __typename: 'Eventer';
  name: Scalars['String']['output'];
};

export type ExternalTicketRegistrationRequest = {
  __typename: 'ExternalTicketRegistrationRequest';
  /**  外部チケット登録スケジュール  */
  externalTicketRegistrationSchedule: ExternalTicketRegistrationSchedule;
  /**  外部チケット登録リクエストID  */
  id: Scalars['ID']['output'];
  /**  レビュー却下詳細  */
  rejectReason?: Maybe<ExternalTicketRegistrationRequestRejectReason>;
  /**  レビュー結果  */
  reviewResult: ExternalTicketRegistrationReviewResult;
};

/**  外部チケット登録リクエストコネクション  */
export type ExternalTicketRegistrationRequestConnection = {
  __typename: 'ExternalTicketRegistrationRequestConnection';
  /**  エッジ  */
  edges: Array<ExternalTicketRegistrationRequestEdge>;
  /**  ページ情報  */
  pageInfo: PageInfo;
};

/**  外部チケット登録リクエストエッジ  */
export type ExternalTicketRegistrationRequestEdge = {
  __typename: 'ExternalTicketRegistrationRequestEdge';
  /**  カーソル  */
  cursor: Scalars['String']['output'];
  /**  ノード  */
  node: ExternalTicketRegistrationRequest;
};

export enum ExternalTicketRegistrationRequestRejectReason {
  /**  既にチケットを保有しているファンアカウント  */
  AlreadyRegisteredFanAccount = 'ALREADY_REGISTERED_FAN_ACCOUNT',
  /**  既に利用されているチケット  */
  AlreadyUsedTicket = 'ALREADY_USED_TICKET',
  /**  不鮮明  */
  Blurry = 'BLURRY',
  /**  異なる公演のチケット  */
  DifferentPerformance = 'DIFFERENT_PERFORMANCE',
  /**  チケット画像ではない  */
  NotTicketImage = 'NOT_TICKET_IMAGE',
  /**  その他  */
  Other = 'OTHER'
}

/**  外部チケット登録リクエストソート順  */
export enum ExternalTicketRegistrationRequestSortOrder {
  /**  作成日時 降順  */
  CreatedAtDesc = 'CREATED_AT_DESC'
}

export enum ExternalTicketRegistrationReviewResult {
  /**  承認  */
  Approved = 'APPROVED',
  /**  レビュー待ち  */
  Pending = 'PENDING',
  /**  却下  */
  Rejected = 'REJECTED'
}

/**  外部チケット登録スケジュール  */
export type ExternalTicketRegistrationSchedule = {
  __typename: 'ExternalTicketRegistrationSchedule';
  createdAt: Scalars['DateTime']['output'];
  /**  外部チケット登録スケジュール終了日時  */
  endAt: Scalars['DateTime']['output'];
  /**  イベント  */
  event: Event;
  /**  外部チケット登録スケジュールID  */
  id: Scalars['ID']['output'];
  /**  公演  */
  performance: Performance;
  /**  外部チケット登録スケジュール開始日時  */
  startAt: Scalars['DateTime']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**  外部チケット登録リクエスト受付スケジュール ステータス  */
export enum ExternalTicketRegistrationScheduleStatus {
  /**  受付開始前  */
  BeforeRegistration = 'BEFORE_REGISTRATION',
  /**  受付終了  */
  Closed = 'CLOSED',
  /**  受付中  */
  OnRegistration = 'ON_REGISTRATION'
}

/**  ファン情報（他者）  */
export type Fan = {
  __typename: 'Fan';
  createdAt: Scalars['DateTime']['output'];
  iconImage?: Maybe<Image>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  walletAddress: Scalars['String']['output'];
};

/**  Extensionエラーコード  */
export enum FanExtensionErrorCode {
  Internal = 'Internal',
  NotFound = 'NotFound',
  Unauthorized = 'Unauthorized'
}

/**  ファン投稿  */
export type FanPost = ChannelContentBase & {
  __typename: 'FanPost';
  /**  投稿文（ネタバレフラグがTRUEで閲覧権限が無い場合、null）  */
  body?: Maybe<Scalars['String']['output']>;
  channelID: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  /**  投稿ファン  */
  fan: Fan;
  isMasked: Scalars['Boolean']['output'];
  isSpoiler: Scalars['Boolean']['output'];
  parentContent?: Maybe<ChannelContent>;
  /**  親コンテンツ  */
  parentContentID?: Maybe<Scalars['ID']['output']>;
  /**  リアクション  */
  reactions: FanPostReactions;
  /**  スーパーメッセージ情報  */
  superMessageInfo?: Maybe<SuperMessageInfo>;
  ulid: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**  ファン投稿に対するリアクション  */
export type FanPostReactions = {
  __typename: 'FanPostReactions';
  /**  アーティストからのリアクション  */
  artistReactions?: Maybe<Array<ArtistReaction>>;
  /**  自分（ファンアカウント）のリアクション  */
  myReactions?: Maybe<Array<FanReaction>>;
  /**  ファンからのリアクションカウント  */
  reactionCounts: Array<FanReactionCount>;
};

/** ファンリアクション */
export type FanReaction = {
  __typename: 'FanReaction';
  /** チャンネルID */
  channelID: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  fan: Fan;
  id: Scalars['ID']['output'];
  type: FanReactionType;
  /** リアクション対象コンテンツID */
  ulid: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** ファンリアクション別カウント */
export type FanReactionCount = {
  __typename: 'FanReactionCount';
  count: Scalars['Int']['output'];
  type: FanReactionType;
};

/** ファンリアクション 種別 */
export enum FanReactionType {
  Like = 'LIKE'
}

export type FanUserError = {
  /**
   * フィールド
   *
   * どのフィールドでエラーが発生したかを示す。
   * GraphQLエラーと同等の値が設定される想定。
   */
  field?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * エラーメッセージ
   *
   * 他のフィールドから読み取れない補足テキストが設定される。
   * 一般ユーザーに直接見せることを目的とはしておらず、
   * 問い合わせ時に追加情報としてサポートに伝えることを想定している。
   */
  message: Scalars['String']['output'];
};

/** クレジットカード決済のスーパーメッセージを確定 入力 */
export type FinalizeFanSuperMessagePurchaseByCreditCardInput = {
  /**  取引ID  */
  accessID: Scalars['ID']['input'];
};

/** クレジットカード決済のスーパーメッセージを確定 ペイロード */
export type FinalizeFanSuperMessagePurchaseByCreditCardPayload = ErrorHasNotVerifiedEmail | ErrorInternal | ErrorNotFound | ErrorValidationFailed | FinalizeFanSuperMessagePurchaseByCreditCardPayloadSuccess | PurchaseSuperMessageErrorAmountLimitExceeded | PurchaseSuperMessageErrorCardDeclined | PurchaseSuperMessageErrorFanHasAlreadyWithdrawn | PurchaseSuperMessageErrorInsufficientBalance | PurchaseSuperMessageErrorOperationAbortedByUser | PurchaseSuperMessageErrorPaymentProcessingFailure;

/** クレジットカード決済のスーパーメッセージを確定 成功 */
export type FinalizeFanSuperMessagePurchaseByCreditCardPayloadSuccess = ResultBase & {
  __typename: 'FinalizeFanSuperMessagePurchaseByCreditCardPayloadSuccess';
  ok: Scalars['Boolean']['output'];
  /**  注文ID  */
  paymentOrderID: Scalars['ID']['output'];
};

/**  アーティストをフォローする 入力  */
export type FollowArtistsInput = {
  artistIDs: Array<Scalars['ID']['input']>;
};

/**  アーティストをフォローするペイロード  */
export type FollowArtistsPayload = ErrorAlreadyExists | ErrorInternal | ErrorNotFound | ErrorValidationFailed | FollowArtistsPayloadSuccess;

/**  アーティストをフォローするペイロード（成功）  */
export type FollowArtistsPayloadSuccess = ResultBase & {
  __typename: 'FollowArtistsPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

export enum FollowingArtistOrder {
  /**  フォローした日時の降順  */
  FollowedAtDesc = 'FOLLOWED_AT_DESC'
}

export type ForwardPaginationInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};

/**  性別  */
export enum Gender {
  Female = 'Female',
  Male = 'Male',
  NoAnswer = 'NoAnswer'
}

export type GenerateTempPutSignedUrlPayload = ErrorInternal | ErrorNotFound | GenerateTempPutSignedUrlPayloadSuccess;

export type GenerateTempPutSignedUrlPayloadSuccess = ResultBase & {
  __typename: 'GenerateTempPutSignedURLPayloadSuccess';
  /**  署名付きURLの有効期限  */
  expireAt: Scalars['DateTime']['output'];
  ok: Scalars['Boolean']['output'];
  /**  署名付きURL  */
  url: Scalars['String']['output'];
};

/** プロフィールプレビュー項目 */
export enum IdpProfilePreviewField {
  DateOfBirth = 'DATE_OF_BIRTH',
  Email = 'EMAIL',
  Gender = 'GENDER',
  Language = 'LANGUAGE',
  Prefecture = 'PREFECTURE'
}

/** IdP認証後のプロフィール反映プレビュー */
export type IdpSignInProfilePreview = {
  __typename: 'IdpSignInProfilePreview';
  currentValue?: Maybe<Scalars['String']['output']>;
  field: IdpProfilePreviewField;
  incomingValue?: Maybe<Scalars['String']['output']>;
};

export type Image = {
  __typename: 'Image';
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

/**  個人情報を初期設定する（ユーザー登録） 入力  */
export type InitMyInfoInput = {
  birthDay: Scalars['Int']['input'];
  birthMonth: Scalars['Int']['input'];
  birthYear: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  enableRecommendationNotification: Scalars['Boolean']['input'];
  gender: Gender;
  language?: InputMaybe<Language>;
  prefecture: Prefecture;
  realFamilyName: Scalars['String']['input'];
  realFamilyNameKana?: InputMaybe<Scalars['String']['input']>;
  realFirstName: Scalars['String']['input'];
  realFirstNameKana?: InputMaybe<Scalars['String']['input']>;
};

/**  個人情報を初期設定する（ユーザー登録） ペイロード  */
export type InitMyInfoPayload = ErrorEmailVerificationAlreadyInUse | ErrorFanStatusInvalid | ErrorInternal | ErrorNotFound | ErrorValidationFailed | InitMyInfoPayloadSuccess;

/**  個人情報を初期設定する（ユーザー登録） ペイロード（成功）  */
export type InitMyInfoPayloadSuccess = ResultBase & {
  __typename: 'InitMyInfoPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

export enum Language {
  /**  英語  */
  En = 'EN',
  /**  日本語  */
  Ja = 'JA'
}

export type Link = {
  __typename: 'Link';
  /**  リンクキャプション  */
  caption?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /**  ID  */
  id: Scalars['ID']['output'];
  /**  リンク名  */
  name: Scalars['String']['output'];
  /**  優先度（小さいほど上位）  */
  priority: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**  リンクURL  */
  url: Scalars['String']['output'];
};

/** IdP連携ペイロード */
export type LinkAccountWithIdpPayload = ErrorIdpAccountConflict | ErrorInternal | ErrorPermissionDenied | ErrorPreconditionFailed | LinkAccountWithIdpPayloadSuccess;

/** IdP連携成功 */
export type LinkAccountWithIdpPayloadSuccess = ResultBase & {
  __typename: 'LinkAccountWithIdpPayloadSuccess';
  me: Me;
  ok: Scalars['Boolean']['output'];
};

/**  お知らせ（自分への通知）を全て既読にする ペイロード  */
export type MarkAllMyNotificationsAsReadPayload = ErrorInternal | ErrorNotFound | ErrorValidationFailed | MarkAllMyNotificationsAsReadPayloadSuccess;

/**  お知らせ（自分への通知）を全て既読にする ペイロード（成功）  */
export type MarkAllMyNotificationsAsReadPayloadSuccess = ResultBase & {
  __typename: 'MarkAllMyNotificationsAsReadPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

/** チャンネルを既読にする 入力 */
export type MarkAsReadChannelInput = {
  /**  チャンネルID  */
  channelID: Scalars['ID']['input'];
};

/** チャンネルを既読にする ペイロード */
export type MarkAsReadChannelPayload = ErrorInternal | ErrorNotFound | ErrorValidationFailed | MarkAsReadChannelPayloadSuccess;

/** チャンネルを既読にする 成功 */
export type MarkAsReadChannelPayloadSuccess = ResultBase & {
  __typename: 'MarkAsReadChannelPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

/**  保有済みEventバッジを既読にする ペイロード  */
export type MarkEventBadgesAsReadPayload = ErrorInternal | ErrorNotFound | ErrorValidationFailed | MarkEventBadgesAsReadPayloadSuccess;

/**  保有済みEventバッジを既読にする ペイロード（成功）  */
export type MarkEventBadgesAsReadPayloadSuccess = ResultBase & {
  __typename: 'MarkEventBadgesAsReadPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

/**  保有済みEventバッジを既読にする 入力  */
export type MarkMyEventBadgesAsReadInput = {
  /**  既読にするEventバッジのID  */
  ids: Array<Scalars['ID']['input']>;
};

/**  特定のお知らせ（自分への通知）を既読にする 入力  */
export type MarkMyNotificationsAsReadInput = {
  ids: Array<Scalars['ID']['input']>;
};

/**  特定のお知らせ（自分への通知）を既読にする ペイロード  */
export type MarkMyNotificationsAsReadPayload = ErrorInternal | ErrorNotFound | ErrorValidationFailed | MarkMyNotificationsAsReadPayloadSuccess;

/**  お知らせ（自分への通知）を全て既読にする ペイロード（成功）  */
export type MarkMyNotificationsAsReadPayloadSuccess = ResultBase & {
  __typename: 'MarkMyNotificationsAsReadPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

/**  チケットサマリの購入後参照フラグをTrue=既読とする入力  */
export type MarkTicketSummaryAsReadInput = {
  /**  チケット申込ID  */
  ticketApplicationID: Scalars['ID']['input'];
};

/**  チケットサマリの購入後参照フラグをTrue=既読とするペイロード  */
export type MarkTicketSummaryAsReadPayload = ErrorCannotMarkTicketSummaryAsRead | ErrorHasNotVerifiedEmail | ErrorInternal | ErrorNotFound | ErrorValidationFailed | MarkTicketSummaryAsReadPayloadSuccess;

/**  チケットサマリの購入後参照フラグをTrue=既読とするペイロード（成功）  */
export type MarkTicketSummaryAsReadPayloadSuccess = ResultBase & {
  __typename: 'MarkTicketSummaryAsReadPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

/**  Me  */
export type Me = {
  __typename: 'Me';
  /**  アクション可能な公演チャンネルのリストを取得する  */
  actionablePerformanceChannels: PerformanceChannelConnection;
  /**  アーティストオフィシャルアカウントとしてアクション可能な公演チャンネルのリストを取得する  */
  actionablePerformanceChannelsAsArtistOfficial: PerformanceChannelConnection;
  birthDay: Scalars['Int']['output'];
  birthMonth: Scalars['Int']['output'];
  birthYear: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  creditCards?: Maybe<Array<RegisteredCreditCard>>;
  /** @deprecated Use `maskedEmail`. */
  email: Scalars['String']['output'];
  /**  各種Eメール通知設定の有効・無効状態を取得  */
  emailNotificationSettings: Array<MyEmailNotificationSetting>;
  /**  保有済みEventバッジを一覧取得  */
  eventBadges: MyEventBadgeConnection;
  /** フォローしているアーティスト一覧を取得する */
  followingArtists: ArtistConnection;
  gender: Gender;
  iconImage?: Maybe<Image>;
  id: Scalars['ID']['output'];
  isEmailVerified: Scalars['Boolean']['output'];
  /**  お知らせ（自分への通知）の未読数を取得  */
  isUnreadMyNotification: Scalars['Boolean']['output'];
  language?: Maybe<Language>;
  maskedEmail: Scalars['String']['output'];
  /**  お知らせ（自分への通知）を取得  */
  myNotification?: Maybe<MyNotification>;
  /**  お知らせ（自分への通知）のリストを取得  */
  myNotifications: MyNotificationConnection;
  name: Scalars['String']['output'];
  paymentOrder: PaymentOrder;
  paymentOrders: PaymentOrderConnection;
  phoneNumber: Scalars['String']['output'];
  prefecture: Prefecture;
  realFamilyName: Scalars['String']['output'];
  realFamilyNameKana?: Maybe<Scalars['String']['output']>;
  realFirstName: Scalars['String']['output'];
  realFirstNameKana?: Maybe<Scalars['String']['output']>;
  /**  特定公演に紐づく レビュー中 または 有効なチケットサマリを取得する */
  reviewingOrActiveTicketSummaries?: Maybe<Array<TicketSummary>>;
  /**  保有済みSuperMessageバッジを一覧取得  */
  superMessageBadges: MySuperMessageBadgeConnection;
  /**  チケットサマリリストを取得する  */
  ticketSummaries: TicketSummaryConnection;
  /**  特定公演に紐づく未使用または使用済みのチケットサマリリストを取得する  */
  ticketSummariesByPerformance?: Maybe<Array<TicketSummary>>;
  /**  特定チケットサマリを取得する  */
  ticketSummary?: Maybe<TicketSummary>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  walletAddress: Scalars['String']['output'];
};


/**  Me  */
export type MeActionablePerformanceChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<PerformanceChannelSortOrder>;
};


/**  Me  */
export type MeActionablePerformanceChannelsAsArtistOfficialArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<PerformanceChannelSortOrder>;
};


/**  Me  */
export type MeEventBadgesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  artistID?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<EventBadgeOrder>;
};


/**  Me  */
export type MeFollowingArtistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<FollowingArtistOrder>;
};


/**  Me  */
export type MeMyNotificationArgs = {
  id: Scalars['ID']['input'];
};


/**  Me  */
export type MeMyNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isImportant?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<MyNotificationSortOrder>;
};


/**  Me  */
export type MePaymentOrderArgs = {
  id: Scalars['ID']['input'];
};


/**  Me  */
export type MePaymentOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  onlyCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<PaymentOrderSortOrder>;
};


/**  Me  */
export type MeReviewingOrActiveTicketSummariesArgs = {
  performanceID: Scalars['ID']['input'];
};


/**  Me  */
export type MeSuperMessageBadgesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  artistID?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<SuperMessageBadgeOrder>;
};


/**  Me  */
export type MeTicketSummariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<TicketSummarySortOrder>;
  statuses?: InputMaybe<Array<TicketSummaryStatus>>;
};


/**  Me  */
export type MeTicketSummariesByPerformanceArgs = {
  performanceID: Scalars['ID']['input'];
};


/**  Me  */
export type MeTicketSummaryArgs = {
  ticketApplicationID: Scalars['ID']['input'];
};

/** 現在のアカウントをIdPへ移行する入力 */
export type MigrateCurrentAccountToIdpInput = {
  administrativeArea?: InputMaybe<Scalars['String']['input']>;
  countryOfResidence?: InputMaybe<Scalars['String']['input']>;
  /** KLEW 側で生年月日が未設定の場合に補完する (YYYY-MM-DD)。IdP migrate-user の date_of_birth に渡す */
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  marketingOptIn: Scalars['Boolean']['input'];
  password: Scalars['String']['input'];
  termsAccepted: Scalars['Boolean']['input'];
};

/** 現在のアカウントのIdP移行ペイロード */
export type MigrateCurrentAccountToIdpPayload = ErrorInternal | ErrorPreconditionFailed | ErrorValidationFailed | MigrateCurrentAccountToIdpPayloadSuccess;

/** 現在のアカウントのIdP移行成功 */
export type MigrateCurrentAccountToIdpPayloadSuccess = ResultBase & {
  __typename: 'MigrateCurrentAccountToIdpPayloadSuccess';
  ok: Scalars['Boolean']['output'];
  redirectToIdpLogin: Scalars['Boolean']['output'];
  status: MigrateCurrentAccountToIdpStatus;
};

/** 現在のアカウントのIdP移行状態 */
export enum MigrateCurrentAccountToIdpStatus {
  Created = 'CREATED',
  IdpAccountAlreadyExists = 'IDP_ACCOUNT_ALREADY_EXISTS'
}

export type Mutation = {
  __typename: 'Mutation';
  /** ファンからの投稿へリアクションを追加する */
  addArtistReactionToFanPost: AddArtistReactionToFanPostPayload;
  /**  Emailアドレスを変更する  */
  changeEmailAddress: ChangeEmailAddressPayload;
  /**
   *  Emailアドレス認証（設定・変更兼用）
   * @deprecated Use `verifyEmail`
   */
  confirmEmail: VerifyEmailPayload;
  /** IdP認証済みアカウントから新規アカウントを作成する */
  createAccountFromIdp: CreateAccountFromIdpPayload;
  /** チャンネルコンテンツへリアクションする */
  createFanReactionToChannelContent: CreateFanReactionToChannelContentPayload;
  /** アーティストオフィシャルアカウントとしてファン投稿を削除（非表示）にする */
  deleteFanContentAsArtistOfficial: DeleteFanContentAsArtistOfficialPayload;
  /** チャンネルコンテンツへのリアクションを削除する */
  deleteFanReactionToChannelContent: DeleteFanReactionToChannelContentPayload;
  /** アーティスト公演投稿を削除にする */
  deleteMyArtistPerformanceContent: DeleteMyArtistPerformanceContentPayload;
  /** 自身が投稿したファン投稿を削除する */
  deleteMyFanContent: DeleteMyFanContentPayload;
  /**  外部チケット登録にて作成したTicketApplicationを削除する  */
  deleteTicketApplicationCreatedByExternalTicket: DeleteTicketApplicationCreatedByExternalTicketPayload;
  /**  特定のEメール通知設定を無効にする  */
  disableMyEmailNotificationSettings: DisableMyEmailNotificationSettingsPayload;
  dummy?: Maybe<DummyPayload>;
  /**  特定のEメール通知設定を有効にする  */
  enableMyEmailNotificationSettings: EnableMyEmailNotificationSettingsPayload;
  /** クレジットカード決済のスーパーメッセージ購入を確定 */
  finalizeFanSuperMessagePurchaseByCreditCard: FinalizeFanSuperMessagePurchaseByCreditCardPayload;
  /** アーティストをフォローする */
  followArtists: FollowArtistsPayload;
  generateTempPutSignedURL: GenerateTempPutSignedUrlPayload;
  /**  個人情報を初期設定する（ユーザー登録）  */
  initMyInfo: InitMyInfoPayload;
  /**
   * IdP認証済みアカウントを既存アカウントへ連携する。
   * IdP側でemail_verified済みのidentityを、同一emailの既存アカウントへ自動リンクする。
   */
  linkAccountWithIdp: LinkAccountWithIdpPayload;
  /**  お知らせ（自分への通知）を全て既読にする  */
  markAllMyNotificationsAsRead: MarkAllMyNotificationsAsReadPayload;
  /** チャンネルを既読にする */
  markAsReadChannel: MarkAsReadChannelPayload;
  /**  保有済みEventバッジを既読にする  */
  markEventBadgesAsRead: MarkEventBadgesAsReadPayload;
  /**  特定のお知らせ（自分への通知）を既読にする  */
  markMyNotificationsAsRead: MarkMyNotificationsAsReadPayload;
  /**  チケット申込の購入後参照フラグをTrue=既読とする  */
  markTicketSummaryAsRead: MarkTicketSummaryAsReadPayload;
  /** 現在のアカウントをIdPへ移行する */
  migrateCurrentAccountToIdp: MigrateCurrentAccountToIdpPayload;
  /** アーティストオフィシャルアカウントとしてチャンネル投稿をピン留めする */
  pinChannelContentAsArtistOfficial: PinChannelContentAsArtistOfficialPayload;
  /** アーティスト公演投稿を投稿する */
  postArtistPerformanceContent: PostArtistPerformanceContentPayload;
  /** ファン投稿を投稿する（サポート無し） */
  postFanContent: PostFanContentPayload;
  /** 新規クレジットカード決済でスーパーメッセージを購入 */
  postFanSuperMessageByNewCreditCard: PostFanSuperMessageByCreditCardPayload;
  /** 登録済みクレジットカード決済でスーパーメッセージを購入 */
  postFanSuperMessageByRegisteredCreditCard: PostFanSuperMessageByCreditCardPayload;
  /**  トークンを利用してクレジットカードを登録する  */
  registerCreditCardByToken: RegisterCreditCardByTokenPayload;
  /** ファンからの投稿へリアクションを削除する */
  removeArtistReactionFromFanPost: RemoveArtistReactionFromFanPostPayload;
  /**  通報する  */
  report: ReportPayload;
  /**  外部チケット登録をリクエストする  */
  requestExternalTicketRegistration: RequestExternalTicketRegistrationPayload;
  /**
   *  Emailアドレス認証メールを再送する
   * @deprecated Use `resendEmailVerification`
   */
  resendEmailConfirmation: ResendEmailVerificationPayload;
  /**  Emailアドレス認証メールを再送する  */
  resendEmailVerification: ResendEmailVerificationPayload;
  /**  言語を設定する  */
  setMyLanguage: SetMyLanguagePayload;
  /**  公開情報を設定する  */
  setMyPublicProfile: SetMyPublicProfilePayload;
  /** アーティストオフィシャルアカウントとしてチャンネル投稿をネタバレ状態にする */
  spoilChannelContentAsArtistOfficial: SpoilChannelContentAsArtistOfficialPayload;
  /**
   * アーティストオフィシャルアカウントとしてファン投稿をネタバレ状態にする
   * @deprecated No longer supported
   */
  spoilFanContentAsArtistOfficial: SpoilFanContentAsArtistOfficialPayload;
  /** 自身が投稿したファン投稿をネタバレに変更する */
  spoilMyFanContent: SpoilMyFanContentPayload;
  /** アーティストのフォローを解除する */
  unfollowArtists: UnfollowArtistsPayload;
  /** アーティストオフィシャルアカウントとしてチャンネル投稿をピン留め解除する */
  unpinChannelContentAsArtistOfficial: UnpinChannelContentAsArtistOfficialPayload;
  /**  登録済みクレジットカードを削除する  */
  unregisterCreditCard: UnregisterCreditCardPayload;
  /**  個人情報を更新する  */
  updateMyInfo: UpdateMyInfoPayload;
  /**  Emailアドレス認証（設定・変更兼用）  */
  verifyEmail: VerifyEmailPayload;
  /**  退会する  */
  withdraw: WithdrawPayload;
};


export type MutationAddArtistReactionToFanPostArgs = {
  input: AddArtistReactionToFanPostInput;
};


export type MutationChangeEmailAddressArgs = {
  input: ChangeEmailAddressInput;
};


export type MutationConfirmEmailArgs = {
  input: VerifyEmailInput;
};


export type MutationCreateAccountFromIdpArgs = {
  input: CreateAccountFromIdpInput;
};


export type MutationCreateFanReactionToChannelContentArgs = {
  input: CreateFanReactionToChannelContentInput;
};


export type MutationDeleteFanContentAsArtistOfficialArgs = {
  input: DeleteFanContentAsArtistOfficialInput;
};


export type MutationDeleteFanReactionToChannelContentArgs = {
  input: DeleteFanReactionToChannelContentInput;
};


export type MutationDeleteMyArtistPerformanceContentArgs = {
  input: DeleteMyArtistPerformanceContentInput;
};


export type MutationDeleteMyFanContentArgs = {
  input: DeleteMyFanContentInput;
};


export type MutationDeleteTicketApplicationCreatedByExternalTicketArgs = {
  ticketApplicationID: Scalars['ID']['input'];
};


export type MutationDisableMyEmailNotificationSettingsArgs = {
  input: DisableMyEmailNotificationSettingsInput;
};


export type MutationDummyArgs = {
  input?: InputMaybe<DummyInput>;
};


export type MutationEnableMyEmailNotificationSettingsArgs = {
  input: EnableMyEmailNotificationSettingsInput;
};


export type MutationFinalizeFanSuperMessagePurchaseByCreditCardArgs = {
  input: FinalizeFanSuperMessagePurchaseByCreditCardInput;
};


export type MutationFollowArtistsArgs = {
  input: FollowArtistsInput;
};


export type MutationGenerateTempPutSignedUrlArgs = {
  contentType?: InputMaybe<ContentType>;
};


export type MutationInitMyInfoArgs = {
  input: InitMyInfoInput;
};


export type MutationMarkAsReadChannelArgs = {
  input: MarkAsReadChannelInput;
};


export type MutationMarkEventBadgesAsReadArgs = {
  input: MarkMyEventBadgesAsReadInput;
};


export type MutationMarkMyNotificationsAsReadArgs = {
  input: MarkMyNotificationsAsReadInput;
};


export type MutationMarkTicketSummaryAsReadArgs = {
  input: MarkTicketSummaryAsReadInput;
};


export type MutationMigrateCurrentAccountToIdpArgs = {
  input: MigrateCurrentAccountToIdpInput;
};


export type MutationPinChannelContentAsArtistOfficialArgs = {
  input: PinChannelContentAsArtistOfficialInput;
};


export type MutationPostArtistPerformanceContentArgs = {
  input: PostArtistPerformanceContentInput;
};


export type MutationPostFanContentArgs = {
  input: PostFanContentInput;
};


export type MutationPostFanSuperMessageByNewCreditCardArgs = {
  input: PostFanSuperMessageByNewCreditCardInput;
};


export type MutationPostFanSuperMessageByRegisteredCreditCardArgs = {
  input: PostFanSuperMessageByRegisteredCreditCardInput;
};


export type MutationRegisterCreditCardByTokenArgs = {
  input: RegisterCreditCardByTokenInput;
};


export type MutationRemoveArtistReactionFromFanPostArgs = {
  input: RemoveArtistReactionFromFanPostInput;
};


export type MutationReportArgs = {
  input: ReportInput;
};


export type MutationRequestExternalTicketRegistrationArgs = {
  input: RequestExternalTicketRegistrationInput;
};


export type MutationSetMyLanguageArgs = {
  input: SetMyLanguageInput;
};


export type MutationSetMyPublicProfileArgs = {
  input: SetMyPublicProfileInput;
};


export type MutationSpoilChannelContentAsArtistOfficialArgs = {
  input: SpoilChannelContentAsArtistOfficialInput;
};


export type MutationSpoilFanContentAsArtistOfficialArgs = {
  input: SpoilFanContentAsArtistOfficialInput;
};


export type MutationSpoilMyFanContentArgs = {
  input: SpoilMyFanContentInput;
};


export type MutationUnfollowArtistsArgs = {
  input: UnfollowArtistsInput;
};


export type MutationUnpinChannelContentAsArtistOfficialArgs = {
  input: UnpinChannelContentAsArtistOfficialInput;
};


export type MutationUnregisterCreditCardArgs = {
  input: UnregisterCreditCardInput;
};


export type MutationUpdateMyInfoArgs = {
  input: UpdateMyInfoInput;
};


export type MutationVerifyEmailArgs = {
  input: VerifyEmailInput;
};

/**  各種Eメール通知設定  */
export type MyEmailNotificationSetting = {
  __typename: 'MyEmailNotificationSetting';
  isEnabled: Scalars['Boolean']['output'];
  type: MyEmailNotificationType;
};

/**  Eメール通知種類 */
export enum MyEmailNotificationType {
  /**  投稿へのいいね  */
  PostLiked = 'POST_LIKED',
  /**  運営者からのおすすめ  */
  Recommendation = 'RECOMMENDATION'
}

export type MyEventBadge = EventBadge & {
  __typename: 'MyEventBadge';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  image: Image;
  isRead: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  performance: Performance;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**  MyEventバッジ コネクション */
export type MyEventBadgeConnection = {
  __typename: 'MyEventBadgeConnection';
  edges: Array<MyEventBadgeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/**  MyEventバッジ エッジ */
export type MyEventBadgeEdge = {
  __typename: 'MyEventBadgeEdge';
  cursor: Scalars['String']['output'];
  node: MyEventBadge;
};

export type MyNotification = MyNotificationLinkedToArtist | MyNotificationLinkedToChannel | MyNotificationLinkedToEvent | MyNotificationLinkedToTicketLotteryApplication | MyNotificationLinkedToTicketSummary;

/**  お知らせ（自分への通知）のリスト コネクション  */
export type MyNotificationConnection = {
  __typename: 'MyNotificationConnection';
  edges: Array<MyNotificationEdge>;
  pageInfo: PageInfo;
};

/**  お知らせ（自分への通知）のリスト エッジ  */
export type MyNotificationEdge = {
  __typename: 'MyNotificationEdge';
  cursor: Scalars['String']['output'];
  node: MyNotification;
};

/**  お知らせ（自分への通知） インタフェース */
export type MyNotificationInterface = {
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  endPublicAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  isImportant: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  startPublicAt: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/**  お知らせ（自分への通知） インタフェース */
export type MyNotificationInterfaceBodyArgs = {
  format?: InputMaybe<TagFormat>;
};

export type MyNotificationLinkedToArtist = MyNotificationInterface & {
  __typename: 'MyNotificationLinkedToArtist';
  artistIDOrSlug: Scalars['ID']['output'];
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  endPublicAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  isImportant: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  startPublicAt: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type MyNotificationLinkedToArtistBodyArgs = {
  format?: InputMaybe<TagFormat>;
};

export type MyNotificationLinkedToChannel = MyNotificationInterface & {
  __typename: 'MyNotificationLinkedToChannel';
  artistIDOrSlug: Scalars['ID']['output'];
  body?: Maybe<Scalars['String']['output']>;
  channelID: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  endPublicAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  isImportant: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  startPublicAt: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type MyNotificationLinkedToChannelBodyArgs = {
  format?: InputMaybe<TagFormat>;
};

export type MyNotificationLinkedToEvent = MyNotificationInterface & {
  __typename: 'MyNotificationLinkedToEvent';
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  endPublicAt?: Maybe<Scalars['DateTime']['output']>;
  eventIDOrSlug: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  isImportant: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  startPublicAt: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type MyNotificationLinkedToEventBodyArgs = {
  format?: InputMaybe<TagFormat>;
};

export type MyNotificationLinkedToTicketLotteryApplication = MyNotificationInterface & {
  __typename: 'MyNotificationLinkedToTicketLotteryApplication';
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  endPublicAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  isImportant: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  startPublicAt: Scalars['DateTime']['output'];
  ticketApplicationID: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type MyNotificationLinkedToTicketLotteryApplicationBodyArgs = {
  format?: InputMaybe<TagFormat>;
};

export type MyNotificationLinkedToTicketSummary = MyNotificationInterface & {
  __typename: 'MyNotificationLinkedToTicketSummary';
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  endPublicAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  isImportant: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  startPublicAt: Scalars['DateTime']['output'];
  ticketApplicationID: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type MyNotificationLinkedToTicketSummaryBodyArgs = {
  format?: InputMaybe<TagFormat>;
};

/**  マイお知らせ 並び順  */
export enum MyNotificationSortOrder {
  StartPublicAtDesc = 'START_PUBLIC_AT_DESC'
}

/**  MySuperMessageバッジ（自身のバッジ）  */
export type MySuperMessageBadge = SuperMessageBadgeBase & {
  __typename: 'MySuperMessageBadge';
  artist: Artist;
  badgeAsset: SuperMessageBadgeAsset;
  createdAt: Scalars['DateTime']['output'];
  fan: Fan;
  id: Scalars['ID']['output'];
  image: Image;
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  superMessageReason: SuperMessageReason;
  superMessageReasonID: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**  MySuperMessageバッジ コネクション */
export type MySuperMessageBadgeConnection = {
  __typename: 'MySuperMessageBadgeConnection';
  edges: Array<MySuperMessageBadgeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/**  MySuperMessageバッジ エッジ */
export type MySuperMessageBadgeEdge = {
  __typename: 'MySuperMessageBadgeEdge';
  cursor: Scalars['String']['output'];
  node: MySuperMessageBadge;
};

/**  マイチケット  */
export type MyTicket = {
  __typename: 'MyTicket';
  /**  入場番号/座席番号  */
  admissionNumber?: Maybe<Scalars['String']['output']>;
  /**  チケット移転元ファン  */
  fromFan?: Maybe<Fan>;
  /**  マイチケットID  */
  id: Scalars['ID']['output'];
  /**  入場番号/座席番号が割り当てられているか（未公開期間の場合は未割り当てとなる）  */
  isAdmissionNumberAssigned: Scalars['Boolean']['output'];
  /**  ステータス  */
  status: MyTicketStatus;
};

/** 保有チケットのソート順 */
export enum MyTicketSortOrder {
  IdAsc = 'ID_ASC'
}

/**  マイチケット（個別チケット）ステータス  */
export enum MyTicketStatus {
  /**
   *  期限切れ
   * @deprecated 削除予定
   */
  Expired = 'EXPIRED',
  /**
   *  返金済み
   * @deprecated 削除予定
   */
  Refunded = 'REFUNDED',
  /**
   *  返金リクエスト中
   * @deprecated 削除予定
   */
  RefundRequested = 'REFUND_REQUESTED',
  /**
   *  移転元へ返却済み
   * @deprecated 削除予定
   */
  Returned = 'RETURNED',
  /**
   *  移転済み
   * @deprecated 削除予定
   */
  Transferred = 'TRANSFERRED',
  /**
   *  未使用
   * @deprecated 削除予定
   */
  Unused = 'UNUSED',
  /**
   *  使用済み
   * @deprecated 削除予定
   */
  Used = 'USED',
  /**
   *  移転受け取り待ち
   * @deprecated 削除予定
   */
  WaitingForAccept = 'WAITING_FOR_ACCEPT'
}

export type PageInfo = {
  __typename: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginationInput = {
  backwardPagination?: InputMaybe<BackwardPaginationInput>;
  forwardPagination?: InputMaybe<ForwardPaginationInput>;
};

export enum PaymentFailedReason {
  /**  金額上限超過  */
  AmountLimitExceeded = 'AMOUNT_LIMIT_EXCEEDED',
  /**  カード決済失敗  */
  CardDeclined = 'CARD_DECLINED',
  /**  残高不足  */
  InsufficientBalance = 'INSUFFICIENT_BALANCE'
}

/** 注文インタフェース */
export type PaymentOrder = {
  /**  総額（税込）  */
  amountIncludingTax: Scalars['Int']['output'];
  /**  作成日時  */
  createdAt: Scalars['DateTime']['output'];
  /**  ファンID  */
  fanID: Scalars['ID']['output'];
  /**  注文ID  */
  id: Scalars['ID']['output'];
  /**  アイテム（Number昇順）  */
  items: Array<PaymentOrderItem>;
  /**  注文に関連するアイテム (注文完了の場合のみ) */
  relatedItem?: Maybe<PaymentRelatedItem>;
  /**  セールID（チケットセールの場合、チケットセールID）  */
  saleID: Scalars['ID']['output'];
  /**  販売種別  */
  saleType: SaleType;
  /**  更新日時  */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PaymentOrderConnection = {
  __typename: 'PaymentOrderConnection';
  edges: Array<PaymentOrderEdge>;
  pageInfo: PageInfo;
};

export type PaymentOrderEdge = {
  __typename: 'PaymentOrderEdge';
  cursor: Scalars['String']['output'];
  node: PaymentOrder;
};

/** 注文アイテム */
export type PaymentOrderItem = {
  __typename: 'PaymentOrderItem';
  /**  作成日時  */
  createdAt: Scalars['DateTime']['output'];
  /**  説明  */
  description?: Maybe<Scalars['String']['output']>;
  /**  ID  */
  id: Scalars['ID']['output'];
  /**  アイテム名  */
  name: Scalars['String']['output'];
  /**  アイテム名（英語）  */
  nameEn: Scalars['String']['output'];
  /**  番号  */
  number: Scalars['Int']['output'];
  /**  金額（税込）  */
  priceIncludingTax: Scalars['Int']['output'];
  /**  数量  */
  quantity: Scalars['Int']['output'];
  /**  更新日時  */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum PaymentOrderSortOrder {
  /**  作成日時の降順  */
  CreatedAtDesc = 'CREATED_AT_DESC'
}

/** 注文に紐づくアイテム */
export type PaymentRelatedItem = PaymentRelatedSuperMessage | PaymentRelatedTickets;

/** 注文に関連するスーパーメッセージ */
export type PaymentRelatedSuperMessage = {
  __typename: 'PaymentRelatedSuperMessage';
  /**  スーパーメッセージバッジ  */
  mySuperMessageBadge: MySuperMessageBadge;
  /**  ファン投稿  */
  post: FanPost;
  /**  感謝メッセージ  */
  thanks_message?: Maybe<Scalars['String']['output']>;
};

export type PaymentRelatedTickets = {
  __typename: 'PaymentRelatedTickets';
  /**  チケットサマリ  */
  ticketSummary: TicketSummary;
};

export enum PaymentStatus {
  /**  キャンセル  */
  Canceled = 'CANCELED',
  /**  完了  */
  Completed = 'COMPLETED',
  /**  失敗  */
  Failed = 'FAILED',
  /**  処理中  */
  Processing = 'PROCESSING'
}

/**  公演  */
export type Performance = {
  __typename: 'Performance';
  /**
   *  出演アーティスト
   * @deprecated Use `performanceArtist`
   */
  artists: Array<Artist>;
  /**  問い合わせEメールアドレス  */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /**  問い合わせ先名  */
  contactName?: Maybe<Scalars['String']['output']>;
  /**  問い合わせ電話番号  */
  contactPhoneNumber?: Maybe<Scalars['String']['output']>;
  /**  問い合わせURL  */
  contactUrl?: Maybe<Scalars['String']['output']>;
  /**  作成日時  */
  createdAt: Scalars['DateTime']['output'];
  /**  説明（テキストのみ）  */
  description?: Maybe<Scalars['String']['output']>;
  /**  公演名（表示用、イベント名と結合し重複部を削除したもの）  */
  displayName: Scalars['String']['output'];
  /**  開場時刻  */
  doorTime?: Maybe<Scalars['DateTime']['output']>;
  /**  終演時刻  */
  endTime?: Maybe<Scalars['DateTime']['output']>;
  /**  イベント  */
  event: Event;
  /**  主催者  */
  eventer?: Maybe<Eventer>;
  /**  紐づく外部チケット登録スケジュール  */
  externalTicketRegistrationSchedule?: Maybe<ExternalTicketRegistrationSchedule>;
  /**  ID  */
  id: Scalars['ID']['output'];
  /**  公演名  */
  name: Scalars['String']['output'];
  /**  注意事項（テキストのみ）  */
  notes?: Maybe<Scalars['String']['output']>;
  /**  出演アーティスト */
  performanceArtists: Array<PerformanceArtist>;
  /**  公演チャンネル  */
  performanceChannels: PerformanceChannelConnection;
  /**  公演日  */
  performanceDate: Scalars['DateTime']['output'];
  /**  検索用キーワード  */
  searchKeywords?: Maybe<Array<Scalars['String']['output']>>;
  /**  スラッグ  */
  slug?: Maybe<Scalars['String']['output']>;
  /**  開演時刻  */
  startTime: Scalars['DateTime']['output'];
  /**  ステータス（紐づく販売スケジュールから情報を集約し返却）  */
  status: PerformanceStatus;
  /**  更新日時  */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**  会場住所  */
  venueAddress?: Maybe<Scalars['String']['output']>;
  /**  会場名  */
  venueName: Scalars['String']['output'];
  /**  会場都道府県  */
  venuePrefecture: Prefecture;
};


/**  公演  */
export type PerformanceDescriptionArgs = {
  format?: InputMaybe<TagFormat>;
};


/**  公演  */
export type PerformanceNotesArgs = {
  format?: InputMaybe<TagFormat>;
};


/**  公演  */
export type PerformancePerformanceChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<PerformanceChannelSortOrder>;
};

/**  公演アーティスト  */
export type PerformanceArtist = {
  __typename: 'PerformanceArtist';
  /**  アーティスト  */
  artist: Artist;
  /**  作成日時  */
  createdAt: Scalars['DateTime']['output'];
  /**  出演アーティストステータス  */
  status: PerformanceArtistStatus;
  /**  更新日時  */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**  公演アーティストステータス  */
export enum PerformanceArtistStatus {
  /**  出演キャンセル  */
  Canceled = 'CANCELED',
  /**  出演決定  */
  Decided = 'DECIDED'
}

export type PerformanceChannel = ChannelInterface & {
  __typename: 'PerformanceChannel';
  /**  アーティスト  */
  artist: Artist;
  artistOfficialsWhoTookAction?: Maybe<Array<ArtistOfficialWhoTookAction>>;
  content: ChannelContent;
  contents: ChannelContentConnection;
  description?: Maybe<Scalars['String']['output']>;
  /**  チャンネル公開終了日時  */
  endPublicAt: Scalars['DateTime']['output'];
  /**  未読有無（非ログインユーザーに関しては常にfalse）  */
  hasUnread: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /**  最終投稿日時（ファン・アーティスト問わず）  */
  lastPostAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  /**  紐づく公演  */
  performance: Performance;
  /**  リクエストしているファンの権限情報  */
  permission: ChannelPermission;
  pinnedChannelContents: PinnedChannelContentConnection;
  superMessageMasters?: Maybe<Array<SuperMessageMaster>>;
  type: ChannelType;
};


export type PerformanceChannelContentArgs = {
  ulid: Scalars['ID']['input'];
};


export type PerformanceChannelContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<ChannelContentsSortOrder>;
};


export type PerformanceChannelDescriptionArgs = {
  format?: InputMaybe<TagFormat>;
};


export type PerformanceChannelPinnedChannelContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<PinnedChannelContentsSortOrder>;
};

export type PerformanceChannelConnection = {
  __typename: 'PerformanceChannelConnection';
  edges: Array<PerformanceChannelEdge>;
  pageInfo: PageInfo;
};

export type PerformanceChannelEdge = {
  __typename: 'PerformanceChannelEdge';
  cursor: Scalars['String']['output'];
  node: PerformanceChannel;
};

export enum PerformanceChannelSortOrder {
  /**  チャンネルの最終投稿日 降順  */
  LastPostAtDesc = 'LAST_POST_AT_DESC',
  /**  チャンネルに紐づく公演の公演日 昇順  */
  PerformanceDateAsc = 'PERFORMANCE_DATE_ASC'
}

/**  各種公演情報  */
export type PerformanceInfo = {
  __typename: 'PerformanceInfo';
  /**  出演アーティスト（紐づく公演から情報を集約し返却）  */
  artists: Array<Artist>;
  /**  イベント期間（紐づく公開中公演から公演日を集約し返却）   */
  eventPeriod: EventPeriod;
  /**  公演一覧（公開中）  */
  performances?: Maybe<Array<Performance>>;
  /**  会場都道府県（紐づく公演から情報を集約し返却）  */
  venuePrefectures: Array<Prefecture>;
};

/**  公演 ステータス  */
export enum PerformanceStatus {
  /**  販売・受付開始前  */
  BeforeSale = 'BEFORE_SALE',
  /**  公演キャンセル  */
  Cancelled = 'CANCELLED',
  /**  受付終了  */
  Closed = 'CLOSED',
  /**  公演終了  */
  Ended = 'ENDED',
  /**  販売・受付中  */
  OnSale = 'ON_SALE',
  /**  完売  */
  SoldOut = 'SOLD_OUT'
}

/**  ピックアップアーティスト  */
export type PickupArtist = {
  __typename: 'PickupArtist';
  /**  アーティスト  */
  artist: Artist;
  /**  作成日時  */
  createdAt: Scalars['DateTime']['output'];
  /**  ID  */
  id: Scalars['ID']['output'];
  /**  優先度（小さいほど優先する） */
  priority: Scalars['Int']['output'];
  /**  更新日時  */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PickupArtistConnection = {
  __typename: 'PickupArtistConnection';
  /**  エッジ  */
  edges: Array<PickupArtistEdge>;
  /**  ページ情報  */
  pageInfo: PageInfo;
};

export type PickupArtistEdge = {
  __typename: 'PickupArtistEdge';
  /**  カーソル  */
  cursor: Scalars['String']['output'];
  /**  ノード  */
  node: PickupArtist;
};

export enum PickupArtistSortOrder {
  /**  優先度昇順  */
  PriorityAsc = 'PRIORITY_ASC'
}

/**  ピックアップイベント  */
export type PickupEvent = {
  __typename: 'PickupEvent';
  /**  作成日時  */
  createdAt: Scalars['DateTime']['output'];
  /**  イベント  */
  event: Event;
  /**  ID  */
  id: Scalars['ID']['output'];
  /**  優先度（小さいほど優先する） */
  priority: Scalars['Int']['output'];
  /**  更新日時  */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PickupEventConnection = {
  __typename: 'PickupEventConnection';
  /**  エッジ  */
  edges: Array<PickupEventEdge>;
  /**  ページ情報  */
  pageInfo: PageInfo;
};

export type PickupEventEdge = {
  __typename: 'PickupEventEdge';
  /**  カーソル  */
  cursor: Scalars['String']['output'];
  /**  ノード  */
  node: PickupEvent;
};

export enum PickupEventSortOrder {
  /**  優先度昇順  */
  PriorityAsc = 'PRIORITY_ASC'
}

/** アーティストオフィシャルアカウントとしてチャンネル投稿をピン留めする 入力 */
export type PinChannelContentAsArtistOfficialInput = {
  /**  チャンネルID  */
  channelID: Scalars['ID']['input'];
  /**  ULID  */
  ulid: Scalars['ID']['input'];
};

/** アーティストオフィシャルアカウントとしてチャンネル投稿をピン留めする ペイロード */
export type PinChannelContentAsArtistOfficialPayload = ErrorInternal | ErrorNotFound | ErrorNotMyChannelContent | ErrorValidationFailed | PinChannelContentAsArtistOfficialPayloadSuccess;

/** アーティストオフィシャルアカウントとしてチャンネル投稿をピン留めする 成功 */
export type PinChannelContentAsArtistOfficialPayloadSuccess = ResultBase & {
  __typename: 'PinChannelContentAsArtistOfficialPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

/**  ピン留めされているチャンネルコンテンツ  */
export type PinnedChannelContent = {
  __typename: 'PinnedChannelContent';
  /**  チャンネルコンテンツ  */
  content: ChannelContent;
  /**  ピン留め日時  */
  pinnedAt: Scalars['DateTime']['output'];
};

/**  ピン留めされているチャンネルコンテンツ コネクション  */
export type PinnedChannelContentConnection = {
  __typename: 'PinnedChannelContentConnection';
  edges: Array<PinnedChannelContentEdge>;
  pageInfo: PageInfo;
};

/**  ピン留めされているチャンネルコンテンツ エッジ  */
export type PinnedChannelContentEdge = {
  __typename: 'PinnedChannelContentEdge';
  cursor: Scalars['String']['output'];
  node: PinnedChannelContent;
};

export enum PinnedChannelContentsSortOrder {
  /**  ピン留め日時の昇順  */
  PinnedAtAsc = 'PINNED_AT_ASC'
}

/**  お知らせ（運営からの通知）  */
export type PlatformNotification = {
  __typename: 'PlatformNotification';
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  endPublicAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Image>;
  isImportant: Scalars['Boolean']['output'];
  startPublicAt: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/**  お知らせ（運営からの通知）  */
export type PlatformNotificationBodyArgs = {
  format?: InputMaybe<TagFormat>;
};

/**  お知らせ（運営からの通知）のリスト コネクション  */
export type PlatformNotificationConnection = {
  __typename: 'PlatformNotificationConnection';
  edges: Array<PlatformNotificationEdge>;
  pageInfo: PageInfo;
};

/**  お知らせ（運営からの通知）のリスト エッジ  */
export type PlatformNotificationEdge = {
  __typename: 'PlatformNotificationEdge';
  cursor: Scalars['String']['output'];
  node: PlatformNotification;
};

/**  お知らせ（運営からの通知） 並び順  */
export enum PlatformNotificationSortOrder {
  StartPublicAtDesc = 'START_PUBLIC_AT_DESC'
}

/** アーティスト公演投稿を投稿する 入力 */
export type PostArtistPerformanceContentInput = {
  /**  投稿文  */
  body: Scalars['String']['input'];
  /**  チャンネルID  */
  channelID: Scalars['ID']['input'];
  /**  ネタバレかどうか  */
  isSpoiler: Scalars['Boolean']['input'];
  /**  返信元ID（省略可）  */
  parentContentID?: InputMaybe<Scalars['ID']['input']>;
  /**  投稿画像URL（5枚までを想定）  */
  tempImages?: InputMaybe<Array<UploadedTempFile>>;
};

/** アーティスト公演投稿を投稿する ペイロード */
export type PostArtistPerformanceContentPayload = ErrorDifferentArtistChannel | ErrorInternal | ErrorNotFound | ErrorNotMyArtistContent | ErrorValidationFailed | PostArtistPerformanceContentPayloadSuccess;

/** アーティスト公演投稿を投稿する 成功 */
export type PostArtistPerformanceContentPayloadSuccess = ResultBase & {
  __typename: 'PostArtistPerformanceContentPayloadSuccess';
  ok: Scalars['Boolean']['output'];
  /**  アーティスト投稿  */
  post: ArtistPost;
};

/** ファン投稿を投稿する（サポート無し） 入力 */
export type PostFanContentInput = {
  /**  投稿文  */
  body: Scalars['String']['input'];
  /**  チャンネルID  */
  channelID: Scalars['ID']['input'];
  /**  ネタバレかどうか  */
  isSpoiler: Scalars['Boolean']['input'];
  /**  返信元ID（省略可）  */
  parentContentID?: InputMaybe<Scalars['ID']['input']>;
};

/** ファン投稿を投稿する（サポート無し） ペイロード */
export type PostFanContentPayload = ErrorInternal | ErrorNotFound | ErrorPermissionDenied | ErrorValidationFailed | PostFanContentPayloadSuccess;

/** ファン投稿を投稿する（サポート無し） 成功 */
export type PostFanContentPayloadSuccess = ResultBase & {
  __typename: 'PostFanContentPayloadSuccess';
  ok: Scalars['Boolean']['output'];
  /**  ファン投稿  */
  post: FanPost;
};

/** クレジットカード決済でスーパーメッセージを購入 ペイロード */
export type PostFanSuperMessageByCreditCardPayload = ErrorHasNotVerifiedEmail | ErrorInternal | ErrorNotFound | ErrorPermissionDenied | ErrorRecaptchaScoreError | ErrorValidationFailed | PostFanSuperMessageByCreditCardPayloadSuccess | PurchaseSuperMessageErrorAmountLimitExceeded | PurchaseSuperMessageErrorCardDeclined | PurchaseSuperMessageErrorFanHasAlreadyWithdrawn | PurchaseSuperMessageErrorInsufficientBalance | PurchaseSuperMessageErrorOperationAbortedByUser | PurchaseSuperMessageErrorPaymentProcessingFailure;

/** クレジットカード決済でスーパーメッセージを購入 成功 */
export type PostFanSuperMessageByCreditCardPayloadSuccess = ResultBase & {
  __typename: 'PostFanSuperMessageByCreditCardPayloadSuccess';
  ok: Scalars['Boolean']['output'];
  /**  3Dセキュアを開始するためのリダイレクトURL  */
  redirectUrl: Scalars['String']['output'];
};

/** 新規クレジットカード決済でスーパーメッセージを購入 入力 */
export type PostFanSuperMessageByNewCreditCardInput = {
  /**  投稿文  */
  body: Scalars['String']['input'];
  /**
   * 3Dセキュア認証完了後のコールバックURL
   * コールバックに付与される取引ID(AccessID)を利用して、finalizeFanSuperMessagePurchaseByCreditCardを呼び出す
   */
  callbackUrl: Scalars['String']['input'];
  /**  チャンネルID  */
  channelID: Scalars['ID']['input'];
  /**  クロップ情報  */
  cropInfo: CropInfoInput;
  /**  決済完了後にクレジットカードを登録するか  */
  isRegisterCardAfterPayment: Scalars['Boolean']['input'];
  /**  ネタバレかどうか  */
  isSpoiler: Scalars['Boolean']['input'];
  /**  返信元ID（省略可）  */
  parentContentID?: InputMaybe<Scalars['ID']['input']>;
  /**  スーパーメッセージアセットID  */
  superMessageBadgeAssetID: Scalars['ID']['input'];
  /**  スーパーメッセージマスターID  */
  superMessageMasterID: Scalars['ID']['input'];
  /**  テキストレイアウト情報  */
  textLayoutInfo: TextLayoutInfoInput;
  /**  MPクレカトークン文字列  */
  token: Scalars['String']['input'];
};

/** 登録済みクレジットカード決済でスーパーメッセージを購入 入力 */
export type PostFanSuperMessageByRegisteredCreditCardInput = {
  /**  投稿文  */
  body: Scalars['String']['input'];
  /**
   * 3Dセキュア認証完了後のコールバックURL
   * コールバックに付与される取引ID(AccessID)を利用して、finalizeFanSuperMessagePurchaseByCreditCardを呼び出す
   */
  callbackUrl: Scalars['String']['input'];
  /**  カードID  */
  cardID: Scalars['ID']['input'];
  /**  チャンネルID  */
  channelID: Scalars['ID']['input'];
  /**  クロップ情報  */
  cropInfo: CropInfoInput;
  /**  ネタバレかどうか  */
  isSpoiler: Scalars['Boolean']['input'];
  /**  返信元ID（省略可）  */
  parentContentID?: InputMaybe<Scalars['ID']['input']>;
  /**  スーパーメッセージバッジアセットID  */
  superMessageBadgeAssetID: Scalars['ID']['input'];
  /**  スーパーメッセージマスターID  */
  superMessageMasterID: Scalars['ID']['input'];
  /**  テキストレイアウト情報  */
  textLayoutInfo: TextLayoutInfoInput;
};

export enum Prefecture {
  Aichi = 'Aichi',
  Akita = 'Akita',
  Aomori = 'Aomori',
  Chiba = 'Chiba',
  Ehime = 'Ehime',
  Fukui = 'Fukui',
  Fukuoka = 'Fukuoka',
  Fukushima = 'Fukushima',
  Gifu = 'Gifu',
  Gunma = 'Gunma',
  Hiroshima = 'Hiroshima',
  Hokkaido = 'Hokkaido',
  Hyogo = 'Hyogo',
  Ibaraki = 'Ibaraki',
  Ishikawa = 'Ishikawa',
  Iwate = 'Iwate',
  Kagawa = 'Kagawa',
  Kagoshima = 'Kagoshima',
  Kanagawa = 'Kanagawa',
  Kochi = 'Kochi',
  Kumamoto = 'Kumamoto',
  Kyoto = 'Kyoto',
  Mie = 'Mie',
  Miyagi = 'Miyagi',
  Miyazaki = 'Miyazaki',
  Nagano = 'Nagano',
  Nagasaki = 'Nagasaki',
  Nara = 'Nara',
  Niigata = 'Niigata',
  Oita = 'Oita',
  Okayama = 'Okayama',
  Okinawa = 'Okinawa',
  Osaka = 'Osaka',
  Other = 'Other',
  Saga = 'Saga',
  Saitama = 'Saitama',
  Shiga = 'Shiga',
  Shimane = 'Shimane',
  Shizuoka = 'Shizuoka',
  Tochigi = 'Tochigi',
  Tokushima = 'Tokushima',
  Tokyo = 'Tokyo',
  Tottori = 'Tottori',
  Toyama = 'Toyama',
  Wakayama = 'Wakayama',
  Yamagata = 'Yamagata',
  Yamaguchi = 'Yamaguchi',
  Yamanashi = 'Yamanashi'
}

/**  共通公開ステータス  */
export enum PublishStatus {
  /**  下書き  */
  Draft = 'DRAFT',
  /**  公開終了  */
  Ended = 'ENDED',
  /**  公開前処理中  */
  Processing = 'PROCESSING',
  /**  公開中  */
  Published = 'PUBLISHED',
  /**  公開日時待ち  */
  Ready = 'READY',
  /**  公開前処理待ち  */
  Waiting = 'WAITING',
  /**  公開前処理待ち（ロック中）  */
  WaitingLocked = 'WAITING_LOCKED'
}

/**  カード限度額の超過によるスーパーメッセージ購入エラー  */
export type PurchaseSuperMessageErrorAmountLimitExceeded = FanUserError & {
  __typename: 'PurchaseSuperMessageErrorAmountLimitExceeded';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/**  カード起因のエラーによるスーパーメッセージ購入エラー  */
export type PurchaseSuperMessageErrorCardDeclined = FanUserError & {
  __typename: 'PurchaseSuperMessageErrorCardDeclined';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/**  退会済みのファンによるスーパーメッセージ購入エラー  */
export type PurchaseSuperMessageErrorFanHasAlreadyWithdrawn = FanUserError & {
  __typename: 'PurchaseSuperMessageErrorFanHasAlreadyWithdrawn';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/**  カード残高不足によるスーパーメッセージ購入エラー  */
export type PurchaseSuperMessageErrorInsufficientBalance = FanUserError & {
  __typename: 'PurchaseSuperMessageErrorInsufficientBalance';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/**  ユーザーによる操作中断によるスーパーメッセージ購入エラー  */
export type PurchaseSuperMessageErrorOperationAbortedByUser = FanUserError & {
  __typename: 'PurchaseSuperMessageErrorOperationAbortedByUser';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/**  クレジットカード決済のスーパーメッセージ購入処理中エラー  */
export type PurchaseSuperMessageErrorPaymentProcessingFailure = FanUserError & {
  __typename: 'PurchaseSuperMessageErrorPaymentProcessingFailure';
  detail?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

export type Query = {
  __typename: 'Query';
  _service: _Service;
  /** 現在のアカウントをIdPへ移行する際の必要項目を取得する */
  accountMigrationRequirements: AccountMigrationRequirementsPayload;
  /**  アーティスト情報を取得する  */
  artist?: Maybe<Artist>;
  dummy: Scalars['String']['output'];
  /**  イベント  */
  event: Event;
  /**  ファン情報（自身）を取得する  */
  me?: Maybe<Me>;
  /**  チャンネルIDを指定して、自身に紐付けられたアーティストオフィシャル一覧を取得する  */
  myArtistOfficialsByChannelID?: Maybe<Array<ArtistOfficial>>;
  /**  公演  */
  performance?: Maybe<Performance>;
  /**  特定公演チャンネルの情報を取得する  */
  performanceChannel: PerformanceChannel;
  /** 運営ピックアップアーティストのリスト取得 */
  pickupArtists: PickupArtistConnection;
  /** 運営ピックアップイベントリスト */
  pickupEvents: PickupEventConnection;
  /**  お知らせ（運営からの通知）の取得  */
  platformNotification?: Maybe<PlatformNotification>;
  /**  お知らせ（運営からの通知）のリストを取得  */
  platformNotifications: PlatformNotificationConnection;
  /** IdP認証後、access token CookieでUserInfoを取得し、アカウント状態を解決する */
  resolveIdpSignIn: ResolveIdpSignInPayload;
  /**  動的なシステムメッセージを取得する  */
  systemMessage: Scalars['String']['output'];
  /** トップカルーセルのリスト取得 */
  topCarousels?: Maybe<Array<TopCarousel>>;
};


export type QueryArtistArgs = {
  idOrSlug: Scalars['ID']['input'];
};


export type QueryDummyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEventArgs = {
  idOrSlug: Scalars['ID']['input'];
};


export type QueryMyArtistOfficialsByChannelIdArgs = {
  channelID: Scalars['ID']['input'];
};


export type QueryPerformanceArgs = {
  idOrSlug: Scalars['ID']['input'];
};


export type QueryPerformanceChannelArgs = {
  artistIDorSlug?: InputMaybe<Scalars['ID']['input']>;
  channelID: Scalars['ID']['input'];
};


export type QueryPickupArtistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<PickupArtistSortOrder>;
};


export type QueryPickupEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<PickupEventSortOrder>;
};


export type QueryPlatformNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlatformNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isImportant?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<PlatformNotificationSortOrder>;
};


export type QuerySystemMessageArgs = {
  type: SystemMessageType;
};


export type QueryTopCarouselsArgs = {
  sortOrder?: InputMaybe<TopCarouselSortOrder>;
};

export enum RecaptchaAction {
  CartAdd = 'cart_add',
  CartView = 'cart_view',
  Checkout = 'checkout',
  GetPrice = 'get_price',
  Login = 'login',
  PasswordReset = 'password_reset',
  PaymentAdd = 'payment_add',
  PlaySong = 'play_song',
  Signup = 'signup',
  TransactionConfirmed = 'transaction_confirmed'
}

/**  申込受付方法  */
export enum ReceptionMethod {
  /**  外部チケット登録  */
  ExternalTicketRegistration = 'EXTERNAL_TICKET_REGISTRATION',
  /**  先着  */
  FirstComeFirstServe = 'FIRST_COME_FIRST_SERVE',
  /**  抽選  */
  Lottery = 'LOTTERY'
}

/**  クレジットカード登録用入力(トークン利用)  */
export type RegisterCreditCardByTokenInput = {
  /**  カードID (登録済みカードを更新する場合に指定)  */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**  デフォルトカードに設定するか  */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /**  トークン  */
  token: Scalars['String']['input'];
};

/**  クレジットカード登録用ペイロード  */
export type RegisterCreditCardByTokenPayload = ErrorCreditCardRegistrationLimitExceeded | ErrorInternal | ErrorNotFound | RegisterCreditCardByTokenPayloadSuccess;

/**  クレジットカード登録用ペイロード（成功）  */
export type RegisterCreditCardByTokenPayloadSuccess = ResultBase & {
  __typename: 'RegisterCreditCardByTokenPayloadSuccess';
  /**  登録済したクレジットカード  */
  creditCard: RegisteredCreditCard;
  ok: Scalars['Boolean']['output'];
};

/**  登録済みクレジットカード  */
export type RegisteredCreditCard = {
  __typename: 'RegisteredCreditCard';
  /**  ブランド  */
  brand: CreditCardBrand;
  /**  有効期限(月)  */
  expiryMonth: Scalars['String']['output'];
  /**  有効期限(年)  */
  expiryYear: Scalars['String']['output'];
  /**  ID  */
  id: Scalars['ID']['output'];
  /**  前回利用カードかどうか  */
  isUsedTheLastTime: Scalars['Boolean']['output'];
  /**  マスキングされたカード番号  */
  number: Scalars['String']['output'];
};

/** ファンからの投稿へリアクション削除 入力 */
export type RemoveArtistReactionFromFanPostInput = {
  /** チャンネルID */
  channelID: Scalars['ID']['input'];
  type: ArtistReactionType;
  /** リアクション対象コンテンツID */
  ulid: Scalars['ID']['input'];
};

/** ファンからの投稿へリアクション削除 ペイロード */
export type RemoveArtistReactionFromFanPostPayload = ErrorInternal | ErrorNotFound | ErrorValidationFailed | RemoveArtistReactionFromFanPostPayloadSuccess;

/** ファンからの投稿へリアクション削除 成功 */
export type RemoveArtistReactionFromFanPostPayloadSuccess = ResultBase & {
  __typename: 'RemoveArtistReactionFromFanPostPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

/** 通報する 入力 */
export type ReportInput = {
  /**  チャンネルID（チャンネルコンテンツの場合）  */
  channelID?: InputMaybe<Scalars['ID']['input']>;
  /**  通報理由の詳細  */
  detail?: InputMaybe<Scalars['String']['input']>;
  /**  通報理由（enum）  */
  reasonType: ReportReasonType;
  /**  通報対象ID（FanPost・ArtistPostの場合、Ulidを設定する）  */
  targetID: Scalars['ID']['input'];
  /**  通報する対象のタイプ  */
  type: ReportTargetType;
};

/** 通報する ペイロード */
export type ReportPayload = ErrorInternal | ErrorNotFound | ErrorValidationFailed | ReportPayloadSuccess;

export type ReportPayloadSuccess = ResultBase & {
  __typename: 'ReportPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

export enum ReportReasonType {
  /**  不適切な内容  */
  InappropriateContent = 'INAPPROPRIATE_CONTENT',
  /**  権利侵害  */
  InfringementOfRights = 'INFRINGEMENT_OF_RIGHTS',
  /**  その他  */
  Other = 'OTHER',
  /**  過度なネタバレ  */
  Spoiler = 'SPOILER'
}

export enum ReportTargetType {
  /**  アーティスト投稿  */
  ArtistPost = 'ARTIST_POST',
  /**  ファンの投稿  */
  FanPost = 'FAN_POST'
}

/**  外部チケット登録をリクエストする入力  */
export type RequestExternalTicketRegistrationInput = {
  /**  外部チケット登録スケジュールID  */
  externalTicketRegistrationScheduleId: Scalars['ID']['input'];
  /**  チケット申込ID（再アップロード時のみ）  */
  ticketApplicationID?: InputMaybe<Scalars['ID']['input']>;
  /**  チケット画像URL  */
  ticketImageTempUrl: Scalars['String']['input'];
};

/**  外部チケット登録をリクエストするペイロード  */
export type RequestExternalTicketRegistrationPayload = ErrorAlreadyHasReviewingOrActiveTicketApplication | ErrorExternalTicketRegistrationScheduleHasEnded | ErrorInternal | ErrorNotFound | ErrorValidationFailed | RequestExternalTicketRegistrationPayloadSuccess;

/**  外部チケット登録をリクエストするペイロード（成功）  */
export type RequestExternalTicketRegistrationPayloadSuccess = ResultBase & {
  __typename: 'RequestExternalTicketRegistrationPayloadSuccess';
  ok: Scalars['Boolean']['output'];
  /**  チケット申込ID  */
  ticketApplicationID: Scalars['ID']['output'];
};

/**  Emailアドレス認証メール再送用ペイロード  */
export type ResendEmailVerificationPayload = ErrorEmailVerificationAlreadyVerified | ErrorInternal | ErrorNotFound | ResendEmailVerificationPayloadSuccess;

/**  Emailアドレス認証メール再送用ペイロード（成功）  */
export type ResendEmailVerificationPayloadSuccess = ResultBase & {
  __typename: 'ResendEmailVerificationPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

/** IdP認証後のアカウント状態解決結果 */
export type ResolveIdpSignInPayload = {
  __typename: 'ResolveIdpSignInPayload';
  maskedEmail?: Maybe<Scalars['String']['output']>;
  profilePreview: Array<IdpSignInProfilePreview>;
  status: ResolveIdpSignInStatus;
};

/** IdP認証後のアカウント状態 */
export enum ResolveIdpSignInStatus {
  /** 同じメールアドレスの既存アカウントがあり、まだIdP identityとは未連携 */
  AccountFoundUnlinked = 'ACCOUNT_FOUND_UNLINKED',
  /** 同じメールアドレスの既存アカウントがない */
  AccountNotFound = 'ACCOUNT_NOT_FOUND',
  /** IdP identityが既存アカウントに連携済み */
  AlreadyLinked = 'ALREADY_LINKED',
  /** 同じメールアドレスまたはIdP identityが別アカウントに紐付いていて自動判定できない */
  Conflict = 'CONFLICT',
  /** UserInfoのemail_verifiedがfalse */
  EmailNotVerified = 'EMAIL_NOT_VERIFIED',
  /** access token Cookieがない、またはUserInfo取得に失敗した */
  InvalidToken = 'INVALID_TOKEN'
}

export type ResultBase = {
  ok: Scalars['Boolean']['output'];
};

/**  販売スケジュール ステータス  */
export enum SaleScheduleStatus {
  /**  受付開始前  */
  BeforeSale = 'BEFORE_SALE',
  /**  受付終了  */
  Closed = 'CLOSED',
  /**  販売中  */
  OnSale = 'ON_SALE',
  /**  完売  */
  SoldOut = 'SOLD_OUT'
}

export enum SaleType {
  SuperMessage = 'SUPER_MESSAGE',
  Ticket = 'TICKET'
}

/**  Emailアドレス設定用入力  */
export type SetEmailAddressInput = {
  email: Scalars['String']['input'];
};

/**  Emailアドレス設定用ペイロード  */
export type SetEmailAddressPayload = ErrorInternal | ErrorValidationFailed | SetEmailAddressPayloadSuccess;

/**  Emailアドレス設定用ペイロード（成功）  */
export type SetEmailAddressPayloadSuccess = ResultBase & {
  __typename: 'SetEmailAddressPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

/**  言語設定用入力  */
export type SetMyLanguageInput = {
  language: Language;
};

/**  言語設定用ペイロード  */
export type SetMyLanguagePayload = ErrorInternal | ErrorNotFound | ErrorValidationFailed | SetMyLanguagePayloadSuccess;

/**  言語設定用ペイロード（成功）  */
export type SetMyLanguagePayloadSuccess = ResultBase & {
  __typename: 'SetMyLanguagePayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

/**  公開情報設定用入力  */
export type SetMyPublicProfileInput = {
  iconImageTempUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/**  公開情報設定用ペイロード  */
export type SetMyPublicProfilePayload = ErrorInternal | ErrorNotFound | ErrorValidationFailed | SetMyPublicProfilePayloadSuccess;

/**  公開情報設定用ペイロード（成功）  */
export type SetMyPublicProfilePayloadSuccess = ResultBase & {
  __typename: 'SetMyPublicProfilePayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

/** アーティストオフィシャルアカウントとしてチャンネル投稿をネタバレ状態にする 入力 */
export type SpoilChannelContentAsArtistOfficialInput = {
  /**  チャンネルID  */
  channelID: Scalars['ID']['input'];
  /**  投稿ID  */
  postID: Scalars['ID']['input'];
};

/** アーティストオフィシャルアカウントとしてチャンネル投稿をネタバレ状態にする ペイロード */
export type SpoilChannelContentAsArtistOfficialPayload = ErrorInternal | ErrorNotFound | ErrorNotMyChannelContent | ErrorValidationFailed | SpoilChannelContentAsArtistOfficialPayloadSuccess;

/** アーティストオフィシャルアカウントとしてチャンネル投稿をネタバレ状態にする 成功 */
export type SpoilChannelContentAsArtistOfficialPayloadSuccess = ResultBase & {
  __typename: 'SpoilChannelContentAsArtistOfficialPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

/** アーティストオフィシャルアカウントとしてファン投稿をネタバレ状態にする 入力 */
export type SpoilFanContentAsArtistOfficialInput = {
  /**  チャンネルID  */
  channelID: Scalars['ID']['input'];
  /**  投稿ID  */
  postID: Scalars['ID']['input'];
};

/** アーティストオフィシャルアカウントとしてファン投稿をネタバレ状態にする ペイロード */
export type SpoilFanContentAsArtistOfficialPayload = ErrorInternal | ErrorNotFound | ErrorNotMyChannelContent | ErrorValidationFailed | SpoilFanContentAsArtistOfficialPayloadSuccess;

/** アーティストオフィシャルアカウントとしてファン投稿をネタバレ状態にする 成功 */
export type SpoilFanContentAsArtistOfficialPayloadSuccess = ResultBase & {
  __typename: 'SpoilFanContentAsArtistOfficialPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

/** 自身が投稿したファン投稿をネタバレに変更する 入力 */
export type SpoilMyFanContentInput = {
  /**  チャンネルID  */
  channelID: Scalars['ID']['input'];
  /**  コンテンツID（ULID）  */
  ulid: Scalars['ID']['input'];
};

/** 自身が投稿したファン投稿をネタバレに変更する ペイロード */
export type SpoilMyFanContentPayload = ErrorInternal | ErrorNotFound | ErrorNotMyFanContent | ErrorValidationFailed | SpoilMyFanContentPayloadSuccess;

/** 自身が投稿したファン投稿をネタバレに変更する 成功 */
export type SpoilMyFanContentPayloadSuccess = ResultBase & {
  __typename: 'SpoilMyFanContentPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

export enum SuperMessageAreaSize {
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Small = 'SMALL'
}

/**  SuperMessageBadge（他ユーザー向け）  */
export type SuperMessageBadge = SuperMessageBadgeBase & {
  __typename: 'SuperMessageBadge';
  artist: Artist;
  badgeAsset: SuperMessageBadgeAsset;
  createdAt: Scalars['DateTime']['output'];
  fan: Fan;
  id: Scalars['ID']['output'];
  image: Image;
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  superMessageReason: SuperMessageReason;
  superMessageReasonID: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**  スーパーメッセージバッジアセット  */
export type SuperMessageBadgeAsset = {
  __typename: 'SuperMessageBadgeAsset';
  /**  スーパーメッセージバッジアセットID  */
  id: Scalars['ID']['output'];
  /**  スーパーメッセージバッジ画像  */
  image: Image;
  /**  スーパーメッセージバッジアセット名  */
  name: Scalars['String']['output'];
};

/**  SuperMessageバッジ ベース  */
export type SuperMessageBadgeBase = {
  artist: Artist;
  badgeAsset: SuperMessageBadgeAsset;
  createdAt: Scalars['DateTime']['output'];
  fan: Fan;
  id: Scalars['ID']['output'];
  image: Image;
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  superMessageReason: SuperMessageReason;
  superMessageReasonID: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum SuperMessageBadgeOrder {
  /**  作成日時の降順  */
  CreatedAtDesc = 'CREATED_AT_DESC'
}

export type SuperMessageInfo = {
  __typename: 'SuperMessageInfo';
  /**  クロップ情報  */
  cropInfo: CropInfo;
  /**  スーパーメッセージバッジ  */
  superMessageBadge: SuperMessageBadge;
  /**  スーパーメッセージマスタ  */
  superMessageMaster: SuperMessageMaster;
  /**  テキストレイアウト情報  */
  textLayoutInfo: TextLayoutInfo;
};

export type SuperMessageMaster = {
  __typename: 'SuperMessageMaster';
  /**  アーティスト  */
  artist: Artist;
  /**  メッセージマスターアセット  */
  assets: Array<SuperMessageMasterAsset>;
  /**  スーパーメッセージマスタID  */
  id: Scalars['ID']['output'];
  /**  デフォルトフラグ  */
  isDefault: Scalars['Boolean']['output'];
  /**  メッセージエリアサイズ  */
  messageAreaSize: SuperMessageAreaSize;
  /**  入力可能文字数  */
  messageLength: Scalars['Int']['output'];
  /**  価格  */
  price: Scalars['Int']['output'];
};

export type SuperMessageMasterAsset = {
  __typename: 'SuperMessageMasterAsset';
  /**  スーパーメッセージマスターアセット  */
  badgeAsset: SuperMessageBadgeAsset;
  /**  利用可否  */
  isAvailable: Scalars['Boolean']['output'];
  /**  優先度（小さいほど上位）  */
  priority: Scalars['Int']['output'];
};

export enum SuperMessageReason {
  Performance = 'PERFORMANCE'
}

/**  システムメッセージ種別  */
export enum SystemMessageType {
  SiweMessage = 'SIWE_MESSAGE'
}

export enum TagFormat {
  /**  HTML形式  */
  Html = 'HTML',
  /**
   *  PLAIN形式（`<br />` -> `
   * `、その他タグは除去）
   */
  Plain = 'PLAIN'
}

export enum TextAlign {
  Center = 'CENTER',
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type TextLayoutInfo = {
  __typename: 'TextLayoutInfo';
  /**  文字寄せ（左右）  */
  textAlign: TextAlign;
  /**  文字カラー  */
  textHexColor: Scalars['String']['output'];
  /**  文字サイズ  */
  textSizePx: Scalars['Int']['output'];
  /**  文字寄せ（上下）  */
  textVerticalAlign: TextVerticalAlign;
};

export type TextLayoutInfoInput = {
  /**  文字寄せ（左右）  */
  textAlign: TextAlign;
  /**  文字カラー  */
  textHexColor: Scalars['String']['input'];
  /**  文字サイズ  */
  textSizePx: Scalars['Int']['input'];
  /**  文字寄せ（上下）  */
  textVerticalAlign: TextVerticalAlign;
};

export enum TextVerticalAlign {
  Bottom = 'BOTTOM',
  Middle = 'MIDDLE',
  Top = 'TOP'
}

/**  チケット申込  */
export type TicketApplication = {
  __typename: 'TicketApplication';
  createdAt: Scalars['DateTime']['output'];
  /**  ファン  */
  fan: Fan;
  /**  既読フラグ（購入後参照フラグ）  */
  isRead: Scalars['Boolean']['output'];
  /**  公演  */
  performance: Performance;
  /**  合計枚数  */
  quantity: Scalars['Int']['output'];
  /**  受付方法  */
  receptionMethod: ReceptionMethod;
  /**  ステータス  */
  status: TicketApplicationStatus;
  /**  チケット申込ID  */
  ticketApplicationID: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**  チケット申込ステータス  */
export enum TicketApplicationStatus {
  CanceledByEventer = 'CANCELED_BY_EVENTER',
  CanceledByFan = 'CANCELED_BY_FAN',
  CanceledExternalTicket = 'CANCELED_EXTERNAL_TICKET',
  Completed = 'COMPLETED',
  CreditCardAuthorizationInProgress = 'CREDIT_CARD_AUTHORIZATION_IN_PROGRESS',
  CreditCardPaymentInProgress = 'CREDIT_CARD_PAYMENT_IN_PROGRESS',
  Issuing = 'ISSUING',
  PaymentExpired = 'PAYMENT_EXPIRED',
  PaymentFailed = 'PAYMENT_FAILED',
  Refunded = 'REFUNDED',
  RejectedExternalTicketRequest = 'REJECTED_EXTERNAL_TICKET_REQUEST',
  RejectedExternalTicketRequestExpired = 'REJECTED_EXTERNAL_TICKET_REQUEST_EXPIRED',
  ReviewingExternalTicketRequest = 'REVIEWING_EXTERNAL_TICKET_REQUEST',
  TempApply = 'TEMP_APPLY',
  TempReserve = 'TEMP_RESERVE',
  Unspecified = 'UNSPECIFIED',
  WaitingForCreditCardAuthorization = 'WAITING_FOR_CREDIT_CARD_AUTHORIZATION',
  WaitingForCvsPayment = 'WAITING_FOR_CVS_PAYMENT',
  WaitingForLotteryResultCreditCard = 'WAITING_FOR_LOTTERY_RESULT_CREDIT_CARD',
  WaitingForLotteryResultCvs = 'WAITING_FOR_LOTTERY_RESULT_CVS'
}

export enum TicketProvisionType {
  /**  外部チケット登録のみ利用  */
  ExternalOnly = 'EXTERNAL_ONLY',
  /**  内部チケットと外部チケット登録の両方を利用  */
  Hybrid = 'HYBRID',
  /**  内部チケットのみ利用  */
  InternalOnly = 'INTERNAL_ONLY',
  /**  未指定  */
  Unspecified = 'UNSPECIFIED'
}

/**  チケット販売アンケート項目インターフェース  */
export type TicketSaleQuestion = {
  /**  INDEX  */
  index: Scalars['Int']['output'];
  /**  必須フラグ  */
  isQuestionRequired: Scalars['Boolean']['output'];
  /**  質問文  */
  question: Scalars['String']['output'];
};

/**  ラジオボタン形式のアンケート項目  */
export type TicketSaleQuestionRadio = TicketSaleQuestion & {
  __typename: 'TicketSaleQuestionRadio';
  /**  INDEX  */
  index: Scalars['Int']['output'];
  /**  必須フラグ  */
  isQuestionRequired: Scalars['Boolean']['output'];
  /**  選択肢  */
  options: Array<Scalars['String']['output']>;
  /**  質問文  */
  question: Scalars['String']['output'];
};

/**  テキスト形式のアンケート項目  */
export type TicketSaleQuestionText = TicketSaleQuestion & {
  __typename: 'TicketSaleQuestionText';
  /**  INDEX  */
  index: Scalars['Int']['output'];
  /**  必須フラグ  */
  isQuestionRequired: Scalars['Boolean']['output'];
  /**  プレースホルダー  */
  placeholder?: Maybe<Scalars['String']['output']>;
  /**  質問文  */
  question: Scalars['String']['output'];
};

/**  チケットセール ステータス  */
export enum TicketSaleStatus {
  /**  売り止め  */
  Locked = 'LOCKED',
  /**  販売中（在庫が十分にある）  */
  OnSale = 'ON_SALE',
  /**  完売  */
  SoldOut = 'SOLD_OUT',
  /**  在庫僅少  */
  StockLow = 'STOCK_LOW'
}

/**  チケットサマリ（支払い待ち以降ステータスのTicketApplicationを抽象化したもの）  */
export type TicketSummary = {
  __typename: 'TicketSummary';
  /**  外部チケット登録リクエスト  */
  externalTicketRegistrationRequests: ExternalTicketRegistrationRequestConnection;
  /**  既読フラグ（購入後参照フラグ）  */
  isRead: Scalars['Boolean']['output'];
  /**  返金リクエスト可能状態（isTransferred=Trueの場合、Trueにはならない）  */
  isRefundable: Scalars['Boolean']['output'];
  /**  移転によって作成されたフラグ  */
  isTransferred: Scalars['Boolean']['output'];
  /**  支払い期限  */
  paymentExpireAt: Scalars['DateTime']['output'];
  /**  公演  */
  performance: Performance;
  /**  合計枚数  */
  quantity: Scalars['Int']['output'];
  /**  受付方法  */
  receptionMethod: ReceptionMethod;
  /**  ステータス  */
  status: TicketSummaryStatus;
  /**  チケット申込ID  */
  ticketApplicationID: Scalars['ID']['output'];
  /**  チケット（個別チケット）  */
  tickets?: Maybe<Array<MyTicket>>;
};


/**  チケットサマリ（支払い待ち以降ステータスのTicketApplicationを抽象化したもの）  */
export type TicketSummaryExternalTicketRegistrationRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sortOrder?: InputMaybe<ExternalTicketRegistrationRequestSortOrder>;
};


/**  チケットサマリ（支払い待ち以降ステータスのTicketApplicationを抽象化したもの）  */
export type TicketSummaryTicketsArgs = {
  statuses?: InputMaybe<Array<MyTicketStatus>>;
};

/**  チケットサマリ コネクション  */
export type TicketSummaryConnection = {
  __typename: 'TicketSummaryConnection';
  edges: Array<TicketSummaryEdge>;
  pageInfo: PageInfo;
};

/**  チケットサマリ エッジ  */
export type TicketSummaryEdge = {
  __typename: 'TicketSummaryEdge';
  cursor: Scalars['String']['output'];
  node: TicketSummary;
};

/** チケットサマリのソート順 */
export enum TicketSummarySortOrder {
  CreatedAtDesc = 'CREATED_AT_DESC'
}

/**  チケットサマリステータス  */
export enum TicketSummaryStatus {
  /**
   *  全て返金済み
   * @deprecated 削除予定
   */
  AllRefunded = 'ALL_REFUNDED',
  /**
   *  全て返金リクエスト中
   * @deprecated 削除予定
   */
  AllRefundRequested = 'ALL_REFUND_REQUESTED',
  /**  外部チケット登録取消  */
  CanceledExternalTicket = 'CANCELED_EXTERNAL_TICKET',
  /**
   *  申込・決済完了_全て期限切れ（未使用がなく、使用済みもないまま公演終了）
   * @deprecated 削除予定
   */
  CompletedAndAllExpired = 'COMPLETED_AND_ALL_EXPIRED',
  /**
   *  申込・決済完了_全て移転済み（未使用がなく、使用済みもないまま全てを移転済み）
   * @deprecated 削除予定
   */
  CompletedAndAllTransferred = 'COMPLETED_AND_ALL_TRANSFERRED',
  /**
   *  申込・決済完了_全て使用済み（未使用が無く、使用済みがある場合）
   * @deprecated 削除予定
   */
  CompletedAndAllUsed = 'COMPLETED_AND_ALL_USED',
  /**  申込完了_外部チケット  */
  CompletedAndExternalTicket = 'COMPLETED_AND_EXTERNAL_TICKET',
  /**  申込完了_外部チケット（公演終了）  */
  CompletedAndExternalTicketEnd = 'COMPLETED_AND_EXTERNAL_TICKET_END',
  /**
   *  申込・決済完了_未使用あり
   * @deprecated 削除予定
   */
  CompletedAndHasUnused = 'COMPLETED_AND_HAS_UNUSED',
  /**
   *  発行処理中
   * @deprecated 削除予定
   */
  Issuing = 'ISSUING',
  /**
   *  支払い期限切れ
   * @deprecated 削除予定
   */
  PayingExpired = 'PAYING_EXPIRED',
  /**  公演キャンセル  */
  PerformanceCanceled = 'PERFORMANCE_CANCELED',
  /**  外部チケット登録リクエスト審査NG  */
  RejectedExternalTicketRequest = 'REJECTED_EXTERNAL_TICKET_REQUEST',
  /**  外部チケット登録リクエスト審査NG（期限切れ）  */
  RejectedExternalTicketRequestExpired = 'REJECTED_EXTERNAL_TICKET_REQUEST_EXPIRED',
  /**  外部チケット登録リクエスト審査中  */
  ReviewingExternalTicketRequest = 'REVIEWING_EXTERNAL_TICKET_REQUEST',
  /**
   *  コンビニ払い待ち
   * @deprecated 削除予定
   */
  WaitingForCvsPayment = 'WAITING_FOR_CVS_PAYMENT',
  /**
   *  当選後支払い失敗（基本的に当選後のクレジットカード支払い失敗）
   * @deprecated 削除予定
   */
  WinButPaymentFailed = 'WIN_BUT_PAYMENT_FAILED'
}

/**  トップカルーセル  */
export type TopCarousel = {
  __typename: 'TopCarousel';
  /**  作成日時  */
  createdAt: Scalars['DateTime']['output'];
  /**  ID  */
  id: Scalars['ID']['output'];
  /**  画像  */
  image: Image;
  /**  画像alt  */
  imageAlt: Scalars['String']['output'];
  /**  リンクURL  */
  linkUrl: Scalars['String']['output'];
  /**  優先度（小さいほど優先する） */
  priority: Scalars['Int']['output'];
  /**  更新日時  */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum TopCarouselSortOrder {
  /**  優先度昇順  */
  PriorityAsc = 'PRIORITY_ASC'
}

/**  アーティストのフォローを解除する 入力  */
export type UnfollowArtistsInput = {
  artistIDs: Array<Scalars['ID']['input']>;
};

/**  アーティストのフォローを解除するペイロード  */
export type UnfollowArtistsPayload = ErrorAlreadyExists | ErrorInternal | ErrorNotFound | ErrorValidationFailed | UnfollowArtistsPayloadSuccess;

/**  アーティストのフォローを解除するペイロード（成功）  */
export type UnfollowArtistsPayloadSuccess = ResultBase & {
  __typename: 'UnfollowArtistsPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

/** アーティストオフィシャルアカウントとしてチャンネル投稿をピン留め解除する 入力 */
export type UnpinChannelContentAsArtistOfficialInput = {
  /**  チャンネルID  */
  channelID: Scalars['ID']['input'];
  /**  ULID  */
  ulid: Scalars['ID']['input'];
};

/** アーティストオフィシャルアカウントとしてチャンネル投稿をピン留め解除する ペイロード */
export type UnpinChannelContentAsArtistOfficialPayload = ErrorInternal | ErrorNotFound | ErrorNotMyChannelContent | ErrorValidationFailed | UnpinChannelContentAsArtistOfficialPayloadSuccess;

/** アーティストオフィシャルアカウントとしてチャンネル投稿をピン留め解除する 成功 */
export type UnpinChannelContentAsArtistOfficialPayloadSuccess = ResultBase & {
  __typename: 'UnpinChannelContentAsArtistOfficialPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

/**  クレジットカード削除用入力  */
export type UnregisterCreditCardInput = {
  /**  削除するカードのID  */
  id: Scalars['ID']['input'];
};

/**  クレジットカード削除用ペイロード  */
export type UnregisterCreditCardPayload = ErrorInternal | ErrorNotFound | UnregisterCreditCardPayloadSuccess;

/**  クレジットカード削除用ペイロード（成功）  */
export type UnregisterCreditCardPayloadSuccess = ResultBase & {
  __typename: 'UnregisterCreditCardPayloadSuccess';
  CreditCard: RegisteredCreditCard;
  ok: Scalars['Boolean']['output'];
};

/**  個人情報を更新する 入力  */
export type UpdateMyInfoInput = {
  gender?: InputMaybe<Gender>;
  prefecture?: InputMaybe<Prefecture>;
  realFamilyName?: InputMaybe<Scalars['String']['input']>;
  realFamilyNameKana?: InputMaybe<Scalars['String']['input']>;
  realFirstName?: InputMaybe<Scalars['String']['input']>;
  realFirstNameKana?: InputMaybe<Scalars['String']['input']>;
};

/**  個人情報を更新する ペイロード  */
export type UpdateMyInfoPayload = ErrorInternal | ErrorNotFound | ErrorValidationFailed | UpdateMyInfoPayloadSuccess;

/**  個人情報を更新する ペイロード（成功）  */
export type UpdateMyInfoPayloadSuccess = ResultBase & {
  __typename: 'UpdateMyInfoPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

export type UploadedTempFile = {
  id: Scalars['ID']['input'];
  url: Scalars['String']['input'];
};

/**  Emailアドレス認証（設定・変更兼用）入力  */
export type VerifyEmailInput = {
  /**  トークン  */
  token: Scalars['String']['input'];
};

/**  Emailアドレス認証（設定・変更兼用）ペイロード  */
export type VerifyEmailPayload = ErrorEmailVerificationAlreadyInUse | ErrorEmailVerificationAlreadyVerified | ErrorInternal | VerifyEmailPayloadErrorInvalidToken | VerifyEmailPayloadSuccess;

/**  Emailアドレス認証（設定・変更兼用）ペイロード（トークン不正）  */
export type VerifyEmailPayloadErrorInvalidToken = FanUserError & {
  __typename: 'VerifyEmailPayloadErrorInvalidToken';
  field?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
};

/**  Emailアドレス認証（設定・変更兼用）ペイロード（成功）  */
export type VerifyEmailPayloadSuccess = ResultBase & {
  __typename: 'VerifyEmailPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

/**  退会用ペイロード  */
export type WithdrawPayload = ErrorInternal | ErrorNotFound | ErrorPreconditionFailed | WithdrawPayloadSuccess;

/**  退会用ペイロード（成功）  */
export type WithdrawPayloadSuccess = ResultBase & {
  __typename: 'WithdrawPayloadSuccess';
  ok: Scalars['Boolean']['output'];
};

export type _Service = {
  __typename: '_Service';
  sdl?: Maybe<Scalars['String']['output']>;
};

export type CreateAccountFromIdpMutationVariables = Exact<{
  input: CreateAccountFromIdpInput;
}>;


export type CreateAccountFromIdpMutation = { __typename: 'Mutation', createAccountFromIdp: { __typename: 'CreateAccountFromIdpPayloadSuccess', ok: boolean } | { __typename: 'ErrorAlreadyExists', message: string } | { __typename: 'ErrorIdpAccountConflict', message: string } | { __typename: 'ErrorInternal', message: string } | { __typename: 'ErrorPermissionDenied', message: string } | { __typename: 'ErrorPreconditionFailed', message: string } | { __typename: 'ErrorValidationFailed', message: string } };

export type LinkAccountWithIdpMutationVariables = Exact<{ [key: string]: never; }>;


export type LinkAccountWithIdpMutation = { __typename: 'Mutation', linkAccountWithIdp: { __typename: 'ErrorIdpAccountConflict', message: string } | { __typename: 'ErrorInternal', message: string } | { __typename: 'ErrorPermissionDenied', message: string } | { __typename: 'ErrorPreconditionFailed', message: string } | { __typename: 'LinkAccountWithIdpPayloadSuccess', ok: boolean, me: { __typename: 'Me', id: string, maskedEmail: string } } };

export type MigrateCurrentAccountToIdpMutationVariables = Exact<{
  input: MigrateCurrentAccountToIdpInput;
}>;


export type MigrateCurrentAccountToIdpMutation = { __typename: 'Mutation', migrateCurrentAccountToIdp: { __typename: 'ErrorInternal', message: string } | { __typename: 'ErrorPreconditionFailed', message: string } | { __typename: 'ErrorValidationFailed', message: string } | { __typename: 'MigrateCurrentAccountToIdpPayloadSuccess', ok: boolean, status: MigrateCurrentAccountToIdpStatus, redirectToIdpLogin: boolean } };

export type AccountMigrationRequirementsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountMigrationRequirementsQuery = { __typename: 'Query', accountMigrationRequirements: { __typename: 'AccountMigrationRequirementsPayload', requiredFields: Array<AccountMigrationRequiredField>, profilePreview: Array<{ __typename: 'AccountMigrationProfilePreview', field: IdpProfilePreviewField, currentValue?: string | null, outgoingValue?: string | null }> } };

export type ResolveIdpSignInQueryVariables = Exact<{ [key: string]: never; }>;


export type ResolveIdpSignInQuery = { __typename: 'Query', resolveIdpSignIn: { __typename: 'ResolveIdpSignInPayload', status: ResolveIdpSignInStatus, maskedEmail?: string | null, profilePreview: Array<{ __typename: 'IdpSignInProfilePreview', field: IdpProfilePreviewField, currentValue?: string | null, incomingValue?: string | null }> } };


export const CreateAccountFromIdpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAccountFromIdp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAccountFromIdpInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAccountFromIdp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAccountFromIdpPayloadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FanUserError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateAccountFromIdpMutation, CreateAccountFromIdpMutationVariables>;
export const LinkAccountWithIdpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LinkAccountWithIdp"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkAccountWithIdp"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LinkAccountWithIdpPayloadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"maskedEmail"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FanUserError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<LinkAccountWithIdpMutation, LinkAccountWithIdpMutationVariables>;
export const MigrateCurrentAccountToIdpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MigrateCurrentAccountToIdp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MigrateCurrentAccountToIdpInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"migrateCurrentAccountToIdp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MigrateCurrentAccountToIdpPayloadSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"redirectToIdpLogin"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FanUserError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<MigrateCurrentAccountToIdpMutation, MigrateCurrentAccountToIdpMutationVariables>;
export const AccountMigrationRequirementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountMigrationRequirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountMigrationRequirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requiredFields"}},{"kind":"Field","name":{"kind":"Name","value":"profilePreview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"currentValue"}},{"kind":"Field","name":{"kind":"Name","value":"outgoingValue"}}]}}]}}]}}]} as unknown as DocumentNode<AccountMigrationRequirementsQuery, AccountMigrationRequirementsQueryVariables>;
export const ResolveIdpSignInDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ResolveIdpSignIn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolveIdpSignIn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"maskedEmail"}},{"kind":"Field","name":{"kind":"Name","value":"profilePreview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"currentValue"}},{"kind":"Field","name":{"kind":"Name","value":"incomingValue"}}]}}]}}]}}]} as unknown as DocumentNode<ResolveIdpSignInQuery, ResolveIdpSignInQueryVariables>;